<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckAdmin">
        <v-card>
          <v-toolbar class="headline mb-1"
                     dark
                     :color="appColor">
            <span v-if="Process == '1'"> พิจารณาโครงการ</span>
            <span v-else-if="Process == '2'"> พิจารณาอบรม / เดินทางไปปฏิบัติงาน</span>
            <v-spacer></v-spacer>
            <v-btn outlined :color="appColor" dark @click="$root.$refs.Train.ChooseProcess(TypeProject, true);">
              <span style="font-size: 20px;color: white">กลับเมนูหลัก</span>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-expand-transition>
              <v-card v-if="!Details_Cordi"
              >
                <v-row
                    justify="center"
                    class="d-flex justify-center">
                  <v-col
                      cols="12">
                    <v-card-title>
                      <h2 style="font-weight: bold" v-if="Process == '1'">ตารางข้อมูลรายละเอียดโครงการ</h2>
                      <h2 style="font-weight: bold" v-else-if="Process == '2'">ตารางข้อมูลการอบรม /
                        เดินทางไปปฏิบัติงาน</h2>
                    </v-card-title>
                  </v-col>
                </v-row>
                <v-list>
                  <v-list-item class="d-flex justify-center">
                    <v-radio-group row v-model="Process" @change="ChooseProcess">
                      <v-radio label="โครงการ" value="1">
                        <template v-slot:label>
                          <h2 style="font-weight: bold">โครงการ
                            <v-chip :color="appColor" dark class="font-weight-bold">
                              {{
                                allProjectDataTemplate2.filter(item => item.Approve == '0' && item.Project_type == '1').length
                              }}
                            </v-chip>
                          </h2>
                        </template>
                      </v-radio>
                      <v-radio label="อบรม / เดินทางไปปฏิบัติราชการ" value="2">
                        <template v-slot:label>
                          <h2 style="font-weight: bold">อบรม / เดินทางไปปฏิบัติราชการ
                            <v-chip :color="appColor" dark class="font-weight-bold">
                              {{
                                allProjectDataTemplate2.filter(item => item.Project_type == '2' && ((item.IsProcess != '3') || (item.IsProcess == '3' && item.IsExpense == '1'))).length
                              }}
                            </v-chip>
                          </h2>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                  <v-list-item class="justify-center">
                    <v-radio-group class="font-weight-bold" v-model="sortStatus" row>
                      <v-radio label="แสดงทั้งหมด" value="1">
                        <template v-slot:label>
                          <h2 style="font-weight: bold">
                            แสดงทั้งหมด
                          </h2>
                        </template>
                      </v-radio>
                      <v-radio label="เลือกแสดงตามสถานะ" value="2">
                        <template v-slot:label>
                          <h2 style="font-weight: bold">
                            เลือกแสดงตามสถานะ
                          </h2>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-list-item>
                  <v-list-item v-if="sortStatus == '2'">
                    <v-row
                        justify="center"
                        class="justify-center">
                      <v-col
                          cols="12"
                          md="4"
                      >
                        <v-select
                            v-model="selStatus"
                            :items="StatusProject.filter(item => item.id == '1' || item.id == '2' || item.id == '3' || item.id == '4')"
                            item-value="id"
                            item-text="status"
                        >
                          <template v-slot:item="{item}">
                            <h4 class="font-weight-bold">{{ item.status }}
                              <span
                                  style="color: #364eff">{{
                                  allProjectDataToTable.filter(itemProj => itemProj.IsPlanStatus == item.id).length
                                }}</span>
                              รายการ
                            </h4>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
                <v-list>
                  <v-list-item>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="ค้นหา รหัส, หัวข้อ"
                        single-line
                        hide-details
                    ></v-text-field>
                  </v-list-item>
                </v-list>
                <v-row
                    justify="center"
                    class="justify-center">
                  <v-col
                      cols="12"
                  >

                    <!--                        @click:row="GetData"-->
                    <template v-if="Process == '1'">
                      <v-data-table
                          :headers="courseHeaders"
                          :items="sortStatus == '1' ? allProjectDataToTable : allProjectDataToTable.filter(itemProj => itemProj.IsPlanStatus == selStatus)"
                          :search="search"
                          :single-expand="singleExpand"
                          :expanded.sync="expanded"
                          class="elevation-1"
                      >
                        <template v-slot:header.Project_code>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            รหัสโครงการ
                          </v-label>
                        </template>
                        <template v-slot:header.full_Name>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            โครงการ
                          </v-label>
                        </template>
                        <template v-slot:header.Approve>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อนุมัติ
                          </v-label>
                        </template>
                        <template v-slot:header.Project_Status>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            สถานะ
                          </v-label>
                        </template>
                        <template v-slot:item.full_Name="{item}">
                          <div v-html="item.full_Name"></div>
                        </template>
                        <template v-slot:header.Approve_Treasury>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            งานคลัง พิจารณา
                          </v-label>
                        </template>
                        <template v-slot:item.Approve="{item}">
                          <v-chip
                              x-large
                              color="#B39DDB"
                              style="transform: scale(0.8);color: blue"
                              v-if="item.Approve == '0'"
                          >
                            <h3>หน่วยงาน</h3>
                          </v-chip>
                          <v-chip
                              x-large
                              color="#F50057"
                              style="transform: scale(0.8);color: blue"
                              v-if="item.Approve == '1'"
                          >
                            <h3>คณะ</h3>
                          </v-chip>
                        </template>
                        <template v-slot:item.Project_Status="{item}">
                          <v-chip
                              x-large
                              color="#6D4C41"
                              style="transform: scale(0.8);color: white"
                              v-if="item.IsPlanStatus == '1'"
                          >
                            <h3>รอพิจารณา</h3>
                          </v-chip>
                          <v-chip
                              x-large
                              color="#00BFA5"
                              style="transform: scale(0.8);color: blue"
                              v-else-if="item.IsPlanStatus == '2'"
                          >
                            <h3 v-if="item.Approve == '0'">อนุมัติ</h3>
                            <h3 v-else>อนุมัติ(หน่วยงาน)</h3>
                          </v-chip>
                          <v-chip
                              x-large
                              color="#F50057"
                              style="transform: scale(0.8);color: blue"
                              v-else-if="item.IsPlanStatus == '3'"
                          >
                            <h3>ไม่อนุมัติ</h3>
                          </v-chip>
                          <v-chip
                              x-large
                              color="#C0CA33"
                              style="transform: scale(0.8);color: blue"
                              v-else-if="item.IsPlanStatus == '4'"
                          >
                            <h3>แก้ไข</h3>
                          </v-chip>
                          <v-chip
                              x-large
                              color="#76FF03"
                              style="transform: scale(0.8)"
                              v-else-if="item.IsPlanStatus == '6'"
                          >
                            <h3 style="color: white;font-weight: bold">เสร็จสิ้นโครงการ</h3>
                          </v-chip>
                          <v-chip
                              x-large
                              color="#3E2723"
                              style="transform: scale(0.8)"
                              v-else-if="item.IsPlanStatus == '9'"
                          >
                            <h3 style="color: white;font-weight: bold">ยกเลิกโครงการ</h3>
                          </v-chip>
                          <v-chip
                              color="#424242"
                              style="transform: scale(0.8);color: white"
                              v-else
                          >
                            <h3>-</h3>
                          </v-chip>
                        </template>
                        <template v-slot:item.Approve_HR="{item}">
                          <div align="center">
                            <v-icon
                                v-if="item.Approve_HR == '0'"
                            >
                              mdi-exclamation
                            </v-icon>
                            <v-icon
                                color="green"
                                v-else-if="item.Approve_HR == '2'"
                            >
                              mdi-check-circle-outline
                            </v-icon>
                            <v-icon
                                color="red"
                                v-else
                            >
                              mdi-close-circle-outline
                            </v-icon>
                          </div>
                        </template>
                        <template v-slot:item.Approve_Treasury="{item}">
                          <div align="center">
                            <v-icon
                                v-if="item.Approve_Treasury == '0'"
                            >
                              mdi-exclamation
                            </v-icon>
                            <v-icon
                                color="green"
                                v-else-if="item.Approve_Treasury == '2'"
                            >
                              mdi-check-circle-outline
                            </v-icon>
                            <v-icon
                                color="red"
                                v-else
                            >
                              mdi-close-circle-outline
                            </v-icon>
                          </div>
                        </template>
                        <template v-slot:item.Project_Details="{ item }">
                          <v-btn
                              class="font-weight-bold"
                              text
                              color="primary"
                              @click="ShowDetail(item)"
                          >
                            รายละเอียด
                          </v-btn>
                          <v-btn
                              class="font-weight-bold"
                              text
                              color="red"
                              @click="DelProject(item)"
                          >
                            ลบ
                          </v-btn>
                          <!--                        <v-btn
                                                      text
                                                      color="black"
                                                      @click="DelProjectOwner(item)"
                                                      v-if="MeData[0].perid == '46792'"
                                                  >
                                                    ลบข้อมูล
                                                  </v-btn>-->
                        </template>
                      </v-data-table>
                    </template>
                    <template v-else>
                      <v-data-table
                          :headers="travelHeaders"
                          :items="sortStatus == '1' ? allProjectDataToTable : allProjectDataToTable.filter(itemProj => itemProj.IsPlanStatus == selStatus)"
                          :search="search"
                          item-key="Project_code"
                          :single-expand="singleExpand"
                          :expanded.sync="expanded"
                          class="elevation-1"
                      >
                        <template v-slot:header.full_Name>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ชื่องาน / กิจกรรม
                          </v-label>
                        </template>
                        <template v-slot:header.IsPlanStatus>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            สถานะ
                          </v-label>
                        </template>
                        <template v-slot:header.Item_Code>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            item code
                          </v-label>
                        </template>
                        <template v-slot:header.BudgetRequest>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            งบประมาณ
                          </v-label>
                        </template>
                        <template v-slot:header.BudgetArrove>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อนุมัติวงเงิน
                          </v-label>
                        </template>
                        <template v-slot:header.MoneyDisburse>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            จำนวนเงินเบิกจ่าย
                          </v-label>
                        </template>
                        <template v-slot:item.full_Name="{item}">
                          <div v-html="item.full_Name"></div>
                        </template>
                        <template v-slot:item.BudgetRequest="{item}">
                          <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetRequest | currency }}</span>
                        </template>
                        <template v-slot:item.BudgetArrove="{item}">
                      <span style="font-weight: bold;color: #ff6d81"
                            v-if="parseInt(item.IsPlanStatus) > 5">{{ item.BudgetArrove | currency }}</span>
                        </template>
                        <template v-slot:item.MoneyDisburse="{item}">
                      <span style="font-weight: bold;color: #ff6d81"
                            v-if="parseInt(item.IsPlanStatus) > 5">{{ item.MoneyDisburse | currency }}</span>
                        </template>
                        <template v-slot:item.IsPlanStatus="{item}">
                          <v-chip
                              x-large
                              v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                              :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                              style="transform: scale(0.8);"
                          >
                            <h3
                                :style="{'color': StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].font_color,'font-weight': 'bold'}">
                              {{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</h3>
                          </v-chip>
                        </template>
                        <template v-slot:item.Item_Code="props">
                          <v-edit-dialog
                              :return-value.sync="props.item.Item_Code"
                              large
                              persistent
                              @save="save(props.item)"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                          >
                            {{ props.item.Item_Code }}
                            <template v-slot:input>
                              <v-text-field
                                  v-model="props.item.Item_Code"
                                  label=""
                                  single-line
                                  counter
                                  autofocus
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:item.Project_Details="{ item }">
                          <v-btn
                              class="font-weight-bold"
                              text
                              color="#0091EA"
                              @click="ShowDetail(item)"
                          >
                            รายละเอียด
                          </v-btn>
                          <v-btn
                              class="font-weight-bold"
                              text
                              color="#0091EA"
                              @click="OpenLinkApprove(item)"
                          >
                            ลิงค์อนุมัติโครงการ
                          </v-btn>
                          <v-btn color="red" text @click="DelProject(item)"
                                 v-if="(ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                            ลบ
                          </v-btn>
                        </template>
                      </v-data-table>
                    </template>
                  </v-col>
                </v-row>
              </v-card>
            </v-expand-transition>
            <v-card v-if="Details_Cordi"
                    elevation="10"
            >
              <v-list-item>
                <v-btn
                    outlined
                    color="#FF5722"
                    @click="BackMenu">
                  ย้อนกลับ
                </v-btn>
              </v-list-item>
              <template v-if="Process == '1'">
                <v-stepper
                    v-model="e1"
                    vertical
                    :alt-labels="altLabels"
                >
                  <template>
                    <v-stepper-step editable step="1">
                      ข้อมูลโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1"><span>ข้อมูลโครงการ</span>
                          </v-list-item-title>
                          <v-list-item>
                            <v-row justify="space-around">
                              <p>วันที่เริ่มต้นโครงการ</p>
                              <p>วันที่สิ้นสุดโครงการ</p>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row justify="space-around">

                              <v-date-picker
                                  v-model="DateStart"
                                  :landscape="landscape"
                                  :reactive="reactive"
                                  :full-width="fullWidth"
                                  :show-current="showCurrent"
                                  :type="month ? 'month' : 'date'"
                                  :multiple="multiple"
                                  :readonly="readonly"
                                  :disabled="disabled"
                                  locale="th"
                                  :events="enableEvents ? functionEvents : null"
                                  style="border: 1px solid black;border-radius: 5px"
                              ></v-date-picker>

                              <v-date-picker
                                  v-model="DateEnd"
                                  :landscape="landscape"
                                  :reactive="reactive"
                                  :full-width="fullWidth"
                                  :show-current="showCurrent"
                                  :type="month ? 'month' : 'date'"
                                  :multiple="multiple"
                                  :readonly="readonly"
                                  :disabled="disabled"
                                  locale="th"
                                  :events="enableEvents ? functionEvents : null"
                                  style="border: 1px solid black;border-radius: 5px"
                              ></v-date-picker>
                            </v-row>
                          </v-list-item>
                          <v-list-item style="margin-top: 20px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6"
                              >
                                <v-autocomplete
                                    v-model="DepSelect"
                                    label="หน่วยงาน"
                                    :items="depart"
                                    item-text="dep_name"
                                    item-value="dep_id"
                                    disabled
                                >

                                </v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="4"
                              >
                                <v-autocomplete
                                    v-model="FiscalYear"
                                    label="โครการของปี"
                                    :items="FiscalYearData"
                                    item-text="yearth"
                                    item-value="year"
                                    readonly
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="2"
                              >
                                <v-text-field label="ITEM CODE" readonly v-model="itemCode"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="4"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="Project_code" label="รหัสโครงการ"
                                                :rules="[rules.required]"
                                                hide-details="auto"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="5"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="Project_name" label="ชื่อโครงการ"
                                                :rules="[rules.required]"
                                                hide-details="auto"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="3"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      v-model="Project_group"
                                      :items="projectGroup"
                                      item-value="Project_group"
                                      item-text="Project_group_des"
                                      label="ประเภทโครงการ"
                                      readonly
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="Course_code != null">
                            <v-row>
                              <v-col
                                  cols="12"
                                  md="4"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      :items="courseData"
                                      item-text="Course_name"
                                      item-value="Course_code"
                                      :rules="[rules.required]"
                                      v-model="Course_code"
                                      label="หลักสูตร"
                                      disabled
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="2"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="course_group"
                                      label="สาขาประเภทหลักสูตร"
                                      required
                                      disabled
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="2"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      disabled
                                      :items="period"
                                      item-text="name"
                                      item-value="id"
                                      v-model="Period_code"
                                      label="ระยะเวลา"
                                      :rules="[rules.required]"
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="4"
                              >
                                <div class="d-flex flex-column justify-center align-center">
                                  <v-checkbox
                                      v-model="roundNeed"
                                      required
                                      readonly
                                  >
                                    <template v-slot:label>
                                      <span style="font-weight: bold;color: black">มีการกำหนดรุ่นโครงการ</span>
                                    </template>
                                  </v-checkbox>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!--                                                        <v-list-item class="d-flex flex-row justify-center align-center"-->
                          <!--                                                                     v-if="projectNeed">-->
                          <!--                                                            <v-list-item>-->
                          <!--                                                                <v-row>-->
                          <!--                                                                    <v-col-->
                          <!--                                                                            cols="12"-->
                          <!--                                                                            md="6">-->
                          <!--                                                                        <v-row-->
                          <!--                                                                                justify="center">-->
                          <!--                                                                            <v-col-->
                          <!--                                                                                    class="d-flex justify-center"-->
                          <!--                                                                                    cols="12"-->
                          <!--                                                                                    md="8">-->
                          <!--                                                                                <v-data-table-->
                          <!--                                                                                        :headers="courseHeadersCondi"-->
                          <!--                                                                                        :items="courseCondi"-->
                          <!--                                                                                        :search="search"-->
                          <!--                                                                                        item-key="Course_code"-->
                          <!--                                                                                        class="elevation-1"-->
                          <!--                                                                                >-->
                          <!--                                                                                    <template v-slot:header.Course_code>-->
                          <!--                                                                                        <v-label-->
                          <!--                                                                                                fontSize="16px"-->
                          <!--                                                                                                fontWeight="bold">-->
                          <!--                                                                                            รหัสหลักสูตร-->
                          <!--                                                                                        </v-label>-->
                          <!--                                                                                    </template>-->
                          <!--                                                                                    <template v-slot:header.Course_name>-->
                          <!--                                                                                        <v-label-->
                          <!--                                                                                                fontSize="16px"-->
                          <!--                                                                                                fontWeight="bold">-->
                          <!--                                                                                            หลักสูตรที่ต้องผ่าน-->
                          <!--                                                                                        </v-label>-->
                          <!--                                                                                    </template>-->
                          <!--                                                                                    <template v-slot:item.action="{ item }">-->
                          <!--                                                                                        <v-row class="d-flex">-->
                          <!--                                                                                            <v-col-->
                          <!--                                                                                                    cols="6"-->
                          <!--                                                                                                    md="6">-->
                          <!--                                                                                                <v-btn-->
                          <!--                                                                                                        outlined-->
                          <!--                                                                                                        color="#BF360C"-->
                          <!--                                                                                                        @click="DeleteCourse(item)">-->
                          <!--                                                                                                    ลบ-->
                          <!--                                                                                                </v-btn>-->
                          <!--                                                                                            </v-col>-->
                          <!--                                                                                        </v-row>-->
                          <!--                                                                                    </template>-->
                          <!--                                                                                </v-data-table>-->
                          <!--                                                                            </v-col>-->
                          <!--                                                                        </v-row>-->
                          <!--                                                                    </v-col>-->
                          <!--                                                                    <v-col-->
                          <!--                                                                            cols="12"-->
                          <!--                                                                            md="6">-->
                          <!--                                                                        <v-row>-->
                          <!--                                                                            <v-row-->
                          <!--                                                                                    justify="center"-->
                          <!--                                                                                    class="d-flex justify-center">-->
                          <!--                                                                                <v-col-->
                          <!--                                                                                        cols="12"-->
                          <!--                                                                                        md="12">-->
                          <!--                                                                                    <v-data-table-->
                          <!--                                                                                            :headers="dataHeadersCondi"-->
                          <!--                                                                                            :items="DataCondi"-->
                          <!--                                                                                            :search="search"-->
                          <!--                                                                                            item-key="PosWork"-->
                          <!--                                                                                            class="elevation-1"-->
                          <!--                                                                                    >-->
                          <!--                                                                                        <template v-slot:header.PosName>-->
                          <!--                                                                                            <v-label-->
                          <!--                                                                                                    fontSize="16px"-->
                          <!--                                                                                                    fontWeight="bold">-->
                          <!--                                                                                                เงื่อนไขตำแหน่ง, อายุงาน-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:header.Level>-->
                          <!--                                                                                            <v-label-->
                          <!--                                                                                                    fontSize="16px"-->
                          <!--                                                                                                    fontWeight="bold">-->
                          <!--                                                                                                ระดับ-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:header.workAgeStart>-->
                          <!--                                                                                            <v-label-->
                          <!--                                                                                                    fontSize="16px"-->
                          <!--                                                                                                    fontWeight="bold">-->
                          <!--                                                                                                อายุงานเริ่มต้น-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:header.workAgeEnd>-->
                          <!--                                                                                            <v-label-->
                          <!--                                                                                                    fontSize="16px"-->
                          <!--                                                                                                    fontWeight="bold">-->
                          <!--                                                                                                อายุงานสิ้นสุด-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:item.PosName="{ item }">-->
                          <!--                                                                                            <v-label>-->
                          <!--                                                                                                {{item.PosName}}-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:item.Level="{ item }">-->
                          <!--                                                                                            <v-label>-->
                          <!--                                                                                                {{item.Level}}-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template-->
                          <!--                                                                                                v-slot:item.workAgeStart="{ item }">-->
                          <!--                                                                                            <v-label>-->
                          <!--                                                                                                {{item.workAgeStart}} (ปี)-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:item.workAgeEnd="{ item }">-->
                          <!--                                                                                            <v-label>-->
                          <!--                                                                                                {{item.workAgeEnd}} (ปี)-->
                          <!--                                                                                            </v-label>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                        <template v-slot:item.action="{ item }">-->
                          <!--                                                                                            <v-row class="d-flex">-->
                          <!--                                                                                                <v-col-->
                          <!--                                                                                                        cols="6"-->
                          <!--                                                                                                        md="6">-->
                          <!--                                                                                                    <v-btn-->
                          <!--                                                                                                            outlined-->
                          <!--                                                                                                            color="#BF360C"-->
                          <!--                                                                                                            @click="DeleteDataCondi(item)">-->
                          <!--                                                                                                        ลบ-->
                          <!--                                                                                                    </v-btn>-->
                          <!--                                                                                                </v-col>-->
                          <!--                                                                                            </v-row>-->
                          <!--                                                                                        </template>-->
                          <!--                                                                                    </v-data-table>-->
                          <!--                                                                                </v-col>-->
                          <!--                                                                            </v-row>-->
                          <!--                                                                        </v-row>-->
                          <!--                                                                    </v-col>-->
                          <!--                                                                </v-row>-->
                          <!--                                                            </v-list-item>-->
                          <!--                                                        </v-list-item>-->
                          <div v-else align="center" style="padding: 30px">
                                <span style="text-align: center;font-weight: bold;color: #ff6d81;">
                                  ไม่พบข้อมูลหลักสูตร
                                </span>
                          </div>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="CalHourse" label="จำนวน ช.ม"
                                                hide-details="auto"
                                                :rules="[rules.required]"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="CalCredit" label="จำนวน เครดิต"
                                                hide-details="auto"
                                                :rules="[rules.required]"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      :items="PLACESelete"
                                      item-value="id"
                                      item-text="detail"
                                      v-model="PLACE"
                                      label="โครงการถูกจัดขึ้น"
                                      readonly
                                  >
                                  </v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline" v-if="PLACE == '2'">
                                  <v-autocomplete
                                      v-model="Province_id"
                                      :items="provinces_Data"
                                      item-text="name_th"
                                      item-value="code"
                                      label="จังหวัด"
                                      readonly></v-autocomplete>
                                </div>
                                <div class="d-inline" v-if="PLACE == '3'">
                                  <v-autocomplete
                                      v-model="Country_id"
                                      :items="countryData"
                                      item-text="ct_nameTHA"
                                      item-value="ct_code"
                                      label="ประเทศ"
                                      readonly
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="BudgetRequest" label="งบประมาณที่ขอ"
                                                hide-details="auto"
                                                :rules="[rules.required]"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      v-model="WorkBy"
                                      label="จัดโดย"
                                      :items="WorkByData"
                                      item-value="id"
                                      item-text="detail"
                                      readonly></v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="WorkByName"
                                      label="ชื่อผู้จัด"
                                      hide-details="auto"
                                      readonly
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="WorkByPhone"
                                      label="เบอร์โทรติดต่อผู้กรอกข้อมูล"
                                      hide-details="auto"
                                      readonly
                                  ></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="Location"
                                      label="สถานที่จัดโครงการ"
                                      hide-details="auto"
                                      :rules="[rules.required]"
                                      disabled></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="12"
                              >
                                <div class="d-inline">
                                  <v-textarea
                                      v-model="Remarks"
                                      outlined
                                      name=""
                                      label="รายละเอียดประกอบโครงการ"
                                      value=""
                                      readonly
                                  ></v-textarea>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="FileProject.length > 0">
                            <template>
                              <v-row>
                                <v-col cols="12" sm="6" offset-sm="3">
                                  <v-card>
                                    <v-card-title>
                                      ไฟล์เอกสารประกอบ
                                    </v-card-title>
                                    <v-container fluid>
                                      <v-row>
                                        <v-col
                                            v-for="(file_i, index) in FileProject"
                                            :key="index"
                                            class="d-flex child-flex"
                                            cols="12"
                                            md="4"
                                        >
                                          <v-card flat tile>
                                            <v-img
                                                v-if="file_i.type == 'image'"
                                                :src="file_i.src"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-if="file_i.type == 'pdf'"
                                                src="../assets/Image/pdf.png"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-card-text>
                                                                                                <span
                                                                                                    style="font-weight: bold;color: black">
                                                                                                    {{ file_i.name }}
                                                                                                </span>
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-btn text @click="ShowData(file_i.src)">
                                                                                                    <span
                                                                                                        style="color: indigo;font-weight: bold">
                                                                                                        เรียกดู
                                                                                                    </span>
                                              </v-btn>
                                            </v-card-actions>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list-item>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item class="d-flex justify-end">
                        <v-btn
                            color="primary"
                            @click="nextStep(1)"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-stepper-content>
                    <v-stepper-step editable step="2">
                      สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์
                    </v-stepper-step>
                    <v-stepper-content step="2">
                      <!--                      <v-list-item three-line>
                                              <v-list-item-content>
                                                <v-list-item-title class="headline mb-1"><span>Competency</span>
                                                </v-list-item-title>
                                                <v-list-item>
                                                  <v-row class="d-flex justify-center">
                                                    <v-col
                                                        cols="12"
                                                        md="12"
                                                    >
                                                      <v-row class="d-flex justify-center">
                                                        <v-col
                                                            cols="12"
                                                            md="12">
                                                          <v-list-item class="d-flex justify-center"
                                                                       style="margin-top: 20px">
                                                            <v-col
                                                                cols="12"
                                                                md="12">
                                                              <v-responsive>
                                                                <v-spacer></v-spacer>
                                                                <v-text-field v-if="CompetencyToShow.length > 0" label="ค้นหา Competency"
                                                                              v-model="searchCompe"></v-text-field>
                                                              </v-responsive>
                                                              <v-responsive>
                                                                <v-treeview :activatable="true" :items="CompetencyToShow"
                                                                            :search="searchCompe">
                                                                  <template v-slot:prepend="{ item, open }">
                                                                    <v-icon v-if="!item.file" color="blue lighten-2">
                                                                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                                                    </v-icon>
                                                                    <v-icon v-else>
                                                                      {{ files[item.file] }}
                                                                    </v-icon>
                                                                  </template>
                                                                  <template v-slot:label="{ item, active }">
                                                                    <div v-if="isMobile" style="cursor: pointer"
                                                                         @click="ShowCompeDetail(item)">
                                                                      <span style="font-size: 12px;color: black" v-if="!active">
                                                                          {{ item.name }}
                                                                      </span>
                                                                      <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                                                            v-else>
                                                                          {{ item.name }}
                                                                      </span>
                                                                    </div>
                                                                    <div v-else style="cursor: pointer" @click="ShowCompeDetail(item)">
                                                                      <span style="color:black;" v-if="!active">
                                                                          {{ item.name }}
                                                                      </span>
                                                                      <span style="color: #364eff;font-weight: bold" v-else>
                                                                          {{ item.name }}
                                                                      </span>
                                                                    </div>
                                                                  </template>
                                                                </v-treeview>
                                                              </v-responsive>
                                                            </v-col>
                                                          </v-list-item>
                                                        </v-col>
                                                      </v-row>
                                                    </v-col>
                                                  </v-row>
                                                </v-list-item>
                                              </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="d-flex justify-end">
                                              <v-btn text color="red"
                                                     @click="backStep(1)">
                                                <v-icon left>mdi-arrow-left</v-icon>
                                                ย้อนกลับ
                                              </v-btn>
                                              <v-btn
                                                  color="primary"
                                                  @click="nextStep(2)"
                                              >
                                                ถัดไป
                                                <v-icon right>mdi-arrow-right</v-icon>
                                              </v-btn>
                                            </v-list-item>-->

                      <v-list>
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1"><span>Competency</span>
                            </v-list-item-title>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="12"
                                >
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="12">
                                      <v-responsive>
                                        <v-spacer></v-spacer>
                                        <v-text-field label="ค้นหา Competency" v-model="searchCompe"></v-text-field>
                                      </v-responsive>
                                      <v-responsive>
                                        <v-treeview v-model="selection" selectable :activatable="true"
                                                    :items="CompetencyData" :search="searchCompe">
                                          <template v-slot:prepend="{ item, open }">
                                            <v-icon v-if="!item.file" color="blue lighten-2">
                                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                            </v-icon>
                                            <v-icon v-else>
                                              {{ files[item.file] }}
                                            </v-icon>
                                          </template>
                                          <template v-slot:label="{ item, active }">
                                            <div v-if="isMobile" style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                              <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                                    v-else>
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                            <div v-else style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                              <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                          </template>
                                        </v-treeview>
                                      </v-responsive>
                                      <!--<v-list-item>
                                                                                <v-row class="d-flex justify-center">
                                                                                    <v-col class="d-flex justify-center" cols="8"
                                                                                           sm="2">
                                                                                        <v-btn
                                                                                                outlined
                                                                                                color="primary"
                                                                                                @click="InsertCompetency"
                                                                                        >
                                                                                            เพิ่ม Competency
                                                                                        </v-btn>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-list-item>
                                                                            <v-list-item class="d-flex justify-center"
                                                                                         style="margin-top: 20px">
                                                                                <v-data-table
                                                                                        :headers="competencyHeader"
                                                                                        :items="competency_DataForSubmit"
                                                                                        item-key="Competency_code"
                                                                                        class="elevation-1">
                                                                                    <template v-slot:header.Competency_des>
                                                                                        <v-label
                                                                                                fontSize="16px"
                                                                                                fontWeight="bold">
                                                                                            Competency
                                                                                        </v-label>
                                                                                    </template>
                                                                                    <template v-slot:header.UPercent>
                                                                                        <v-label
                                                                                                fontSize="16px"
                                                                                                fontWeight="bold">
                                                                                            เปอเซ็นต์
                                                                                        </v-label>
                                                                                    </template>
                                                                                    <template v-slot:item.Competency_des="{item}">
                                                                                        <span style="font-weight: bold">
                                                                                            {{item.Competency_des}}
                                                                                        </span>
                                                                                    </template>
                                                                                    <template v-slot:item.UPercent="{item}">
                                                                                        <span style="font-weight: bold">
                                                                                            {{item.UPercent}} %
                                                                                        </span>
                                                                                    </template>
                                                                                    <template v-slot:item.action="{item}">
                                                                                        <v-row class="d-flex">
                                                                                            <v-col
                                                                                                    cols="6"
                                                                                                    md="6">
                                                                                                <v-btn
                                                                                                        outlined
                                                                                                        color="#BF360C"
                                                                                                        @click="DeleteCompetency(item)">
                                                                                                    ลบ
                                                                                                </v-btn>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </template>
                                                                                </v-data-table>
                                                                            </v-list-item>-->
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-list-item>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(1)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(2)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step editable step="3">
                      คณะทำงาน
                    </v-stepper-step>
                    <v-stepper-content step="3">
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1"><span>คณะทำงาน</span>
                          </v-list-item-title>
                          <v-list-item>
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="12"
                              >
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                      md="10">
                                    <v-list-item>
                                      <v-label class="d-flex justify-center">
                                        <!--                                        กรรมการผู้ร่วมโครงการ-->
                                      </v-label>
                                    </v-list-item>
                                    <v-list-item class="d-flex justify-center"
                                                 style="margin-top: 20px">
                                      <v-data-table
                                          :headers="CoordinatorHeader"
                                          :items="Coordinator"
                                          item-key="PosWork"
                                          class="elevation-1"
                                          v-if="Coordinator.length > 0"
                                      >
                                        <template v-slot:header.Name>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            ชื่อ - สกุล
                                          </v-label>
                                        </template>
                                        <template v-slot:header.position_com>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            ตำแหน่ง
                                          </v-label>
                                        </template>
                                        <template v-slot:header.Committee_type>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            สถานะ
                                          </v-label>
                                        </template>
                                        <template v-slot:header.TEL>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            เบอร์โทร
                                          </v-label>
                                        </template>
                                        <template v-slot:header.Lecturer>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            วิทยากร
                                          </v-label>
                                        </template>
                                        <template v-slot:item.position_com="{item}">
                                                    <span v-if="item.Committee_code == '1'" style="color: brown">
                                                        ประธาน
                                                    </span>
                                          <span v-if="item.Committee_code == '2'"
                                                style="color: coral">
                                                        รองประธาน
                                                    </span>
                                          <span v-if="item.Committee_code == '3'"
                                                style="color: darkgoldenrod">
                                                        เลขา
                                                    </span>
                                          <span v-if="item.Committee_code == '4'"
                                                style="color: darkseagreen">
                                                        เหรัญญิก
                                                    </span>
                                          <span v-if="item.Committee_code == '5'"
                                                style="color: darkslategrey">
                                                        กรรมการ
                                                    </span>
                                          <span v-if="item.Committee_code == '6'"
                                                style="color: hotpink">
                                                        วิทยากร
                                                    </span><span v-if="item.Committee_code == '7'" style="color: khaki">
                                                        ที่ปรึกษา
                                                    </span><span v-if="item.Committee_code == '8'" style="color: grey">
                                                        ผู้ทรงคุณวุฒิ
                                                    </span>
                                          <span v-if="item.Committee_code == '9'"
                                                style="color: lightskyblue">
                                                        ผู้ประสานงาน
                                                    </span>
                                        </template>
                                        <template v-slot:item.Committee_type="{item}">
                                                    <span v-if="item.Committee_type == '0'" style="color: darkblue">
                                                        บุคลากรคณะแพทย์
                                                    </span>
                                          <span v-if="item.Committee_type == '1'"
                                                style="color: darkblue">
                                                        บุคลากรคณะอื่น
                                                    </span><span v-if="item.Committee_type == '3'"
                                                                 style="color: darkblue">
                                                        บุคคลภายนอก
                                                    </span>
                                        </template>
                                        <template v-slot:item.Lecturer="{item}">
                                          <v-btn text v-if="(item.Committee_code == '5' || item.Committee_code == '6'
                                           || item.Committee_code == '10' || item.Committee_code == '11'
                                            || item.Committee_code == '12' || item.Committee_code == '13' || item.Committee_code == '14') && item.Committee_type == '0'"
                                                 color="primary" @click="ShowDetailLecturer(item)">
                                            รายละเอียด
                                          </v-btn>
                                        </template>
                                      </v-data-table>
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red"
                               @click="backStep(2)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(3)"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-stepper-content>
                    <v-stepper-step editable step="4">
                      ค่าใช้จ่ายโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="4">
                      <v-list-item-title class="headline mb-1"><span>ค่าใช้จ่ายโครงการ</span>
                      </v-list-item-title>
                      <v-list-item>
                        <div class="d-flex flex-column justify-stretch" style="width: 100%">
                          <v-data-table
                              :headers="budgetHeader"
                              :items="budgetData"
                              class="elevation-1"
                          >
                            <template v-slot:item.ReqMoney="{item}">
                              {{ item.ReqMoney | currency }}
                            </template>
                            <template
                                v-slot:footer
                            >
                              <template v-if="BudgetRequest > 0">
                                <div align="center" style="margin-top: 15px">
                                  <span style="font-weight: bold;color: #364eff">งบประมาณที่ขอ : {{
                                      BudgetRequest | currency
                                    }}</span>
                                </div>
                                <div align="center">
                                    <span style="font-weight: bold;color: #ff6d81">ค่าใช้จ่าย : {{
                                        Expense | currency
                                      }}</span>
                                </div>
                                <div align="center">
                              <span
                                  style="font-weight: bold;color: #42b983">คงเหลือ : {{
                                  BudgetRequest - Expense | currency
                                }}</span>
                                </div>
                              </template>
                            </template>
                          </v-data-table>
                        </div>
                      </v-list-item>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red"
                               @click="backStep(3)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(4)"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-stepper-content>
                    <v-stepper-step editable step="5" v-if="!roundNeed">
                      กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วมโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="5" v-if="!roundNeed">
                      <v-list-item-title class="headline mb-1"><span>กลุ่มเป้าหมาย</span>
                      </v-list-item-title>
                      <v-list-item class="d-flex justify-center">
                        <v-data-table
                            :headers="dataHeadersCondi"
                            :items="DataCondi"
                            :search="search"
                            item-key="PosWork"
                            class="elevation-1 mt-4"
                            v-if="DataCondi.length > 0"
                        >
                          <template v-slot:header.PosName>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              เงื่อนไขตำแหน่ง, อายุงาน
                            </v-label>
                          </template>
                          <template v-slot:header.Level>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ระดับ
                            </v-label>
                          </template>
                          <template v-slot:header.workAgeStart>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              อายุงานเริ่มต้น
                            </v-label>
                          </template>
                          <template v-slot:header.workAgeEnd>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              อายุงานสิ้นสุด
                            </v-label>
                          </template>
                          <template v-slot:item.PosName="{ item }">
                            <v-label>
                              {{ item.PosName }}
                            </v-label>
                          </template>
                          <template v-slot:item.Level="{ item }">
                            <v-label>
                              {{ item.Level }}
                            </v-label>
                          </template>
                          <template
                              v-slot:item.workAgeStart="{ item }">
                            <v-label>
                              {{ item.workAgeStart }} (ปี)
                            </v-label>
                          </template>
                          <template v-slot:item.workAgeEnd="{ item }">
                            <v-label>
                              {{ item.workAgeEnd }} (ปี)
                            </v-label>
                          </template>
                          <template v-slot:item.action="{ item }">
                            <v-row class="d-flex">
                              <v-col
                                  cols="6"
                                  md="6">
                                <v-btn
                                    outlined
                                    color="#BF360C"
                                    @click="DeleteDataCondi(item)">
                                  ลบ
                                </v-btn>
                              </v-col>
                            </v-row>
                          </template>
                        </v-data-table>
                      </v-list-item>
                      <v-divider class="mt-6"></v-divider>
                      <v-list-item-title class="headline mt-6">
                        เงื่อนไขการเข้าร่วมโครงการ
                      </v-list-item-title>
                      <v-list-item>
                        <v-list-item-subtitle>
                          สถานะสมัครเข้าร่วมโครงการ
                        </v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center">
                        <v-row>
                          <v-col
                              md="4"
                              cols="12">
                            <span>การเปิดรับสมัคร</span>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12">
                            <span v-if="ChooseTypRegis == '0'"> : อนุญาตสมัครเข้าร่วมโครงการ</span>
                            <span v-else> : ไม่อนุญาตสมัครเข้าร่วมโครงการ</span>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center" v-if="ChooseTypRegis == '0'">
                        <v-row>
                          <v-col
                              md="4"
                              cols="12">
                            <span>อนุญาตให้สมัครเฉพาะ</span>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12">
                            <span v-if="ChooseTypRegis2 == '0'"> : หน่วยงานและบุคลากรทั่วไป</span>
                            <span v-else-if="ChooseTypRegis2 == '1'"> : หน่วยงาน</span>
                            <span v-else> : บุคลากรทั่วไป</span>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center">
                        <v-row>
                          <v-col
                              md="4"
                              cols="12">
                            <span>วันที่เปิดรับสมัคร</span>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12">
                            <span
                                v-if="ChooseTypRegis == '0' && (dateRegStart != '0000-00-00' && dateRegStart != null)"> : {{
                                dateRegStart | dateToThai
                              }}</span>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center">
                        <v-row>
                          <v-col
                              md="4"
                              cols="12">
                            <span>วันที่เปิดรับสมัคร</span>
                          </v-col>
                          <v-col
                              md="6"
                              cols="12">
                        <span
                            v-if="ChooseTypRegis == '0' && (dateRegEnd != '0000-00-00' && dateRegEnd != null)"> : {{
                            dateRegEnd | dateToThai
                          }}</span>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-subtitle>
                          ผู้เข้าร่วมโครงการ
                        </v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center">
                        <v-row>
                          <v-col
                              md="4"
                              cols="12">
                            <span>จำกัดจำนวนผู้เข้าร่วมโครงการ</span>
                          </v-col>
                          <v-col
                              md="4"
                              cols="12">
                        <span
                            v-if="ProjectQuotaCount != '' || ProjectQuotaCount != null || ProjectQuotaCount != '0'"> : {{
                            ProjectQuotaCount
                          }} คน</span>
                            <span v-else> : ไม่จำกัด</span>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-subtitle>
                          โควตาหน่วยงานที่เข้าร่วม
                        </v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item class="d-flex justify-center">
                        <v-data-table
                            :headers="DepQuotaHeader"
                            :items="DepQuotaData"
                            :search="searchDepQuota"
                            class="elevation-1 mt-4"
                        >
                          <template v-slot:header.type>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ประเภท
                            </v-label>
                          </template>
                          <template v-slot:header.dep_name>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ภาควิชา/หน่วยงาน
                            </v-label>
                          </template>
                          <template v-slot:header.count>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              จำนวน/คน
                            </v-label>
                          </template>
                          <template
                              v-slot:footer
                          >
                            <template>
                              <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                              </div>
                              <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(ProjectQuotaCount) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                              </div>
                              <div align="center" v-else>
                                <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                              </div>
                              <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  ProjectQuotaCount
                                }} คน</span>
                              </div>
                              <div align="center" v-else>
                                <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                              </div>
                            </template>
                          </template>
                        </v-data-table>
                      </v-list-item>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red"
                               @click="backStep(4)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(5)"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-stepper-content>
                    <v-stepper-step step="6" editable v-if="!roundNeed">
                      รายชื่อผู้เข้าร่วมโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="6" v-if="!roundNeed">
                      <v-list>
                        <v-card class="mt-7">
                          <v-toolbar
                              color="primary"
                              dark
                              flat
                          >
                            <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการ {{ JoinPerson.length }} <span
                                v-if="!ChkJoinPerson"> / {{ ProjectQuotaCount }}</span> คน
                            </v-toolbar-title>
                          </v-toolbar>
                          <v-card-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="searchPerson"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                v-if="JoinPerson.length > 0"
                            ></v-text-field>
                          </v-card-title>
                          <v-data-table
                              :headers="headersPerson"
                              :items="JoinPerson"
                              :search="searchPerson"
                              v-if="JoinPerson.length > 0"
                          >
                            <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                              <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                            </template>
                            <template v-slot:item.status_reg="{item}">
                              <span style="font-weight: bold;color: #364eff"
                                    v-if="item.status_reg == '1'">ลงทะเบียน</span>
                              <span style="font-weight: bold;color: #ffd54f" v-else>รอลงทะเบียน</span>
                            </template>
                            <template v-slot:item.action="{item}">
                              <v-btn
                                  color="#F44336"
                                  outlined
                                  @click="Del_item(item)">
                                ลบ
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-card>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(5)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(6)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step step="5" editable v-if="roundNeed">
                      รุ่นในการจัดโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="5" v-if="roundNeed">
                      <v-list>
                        <v-list-item-title class="headline mb-1"><span>รุ่นโครงการ</span>
                        </v-list-item-title>
                        <v-list-item class="d-flex justify-center mt-8" v-if="RoundData.length > 0">
                          <v-data-table
                              :headers="roundHeader"
                              :items="RoundData"
                          >
                            <template v-slot:item.action="{item}">
                              <div align="center">
                                <v-btn text color="primary" @click="GetRoundDetail(item)">
                                  รายละเอียด
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(4)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(5)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step editable :step="!roundNeed ? '7' : '6'">
                      ฟอร์มตัวอย่าง, ใบปะหน้าบันทึกข้อความ
                    </v-stepper-step>
                    <v-stepper-content :step="!roundNeed ? '7' : '6'">
                      <v-list>
                        <v-list-item-title class="headline mb-1"><span>ฟอร์มตัวอย่าง, ใบปะหน้าบันทึกข้อความ</span>
                        </v-list-item-title>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                class="d-flex justify-center"
                                cols="12"
                                md="4">
                              <v-btn text color="#FF9800" @click="ChangeForm('1')">
                                ฟอร์มตัวอย่าง
                              </v-btn>
                              <v-btn text color="#FF9800" @click="ChangeForm('2')">
                                ใบปะหน้า
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="10">
                            <v-card class="elevation-2">
                              <div v-html="(form1 ? editorData: editorData2)"></div>
                            </v-card>
                          </v-col>
                        </v-row>
                        <div align="center">
                          <v-btn outlined color="primary" @click="ShowTemplate">
                            พิมพ์โครงการ
                          </v-btn>
                          <!--                    <v-spacer></v-spacer>-->
                          <!--                    <v-btn outlined color="primary" @click="PrintForm">-->
                          <!--                      พิมพ์ฺ-->
                          <!--                    </v-btn>-->
                        </div>
                        <!--                  <div style="width: 100%;margin-top: 20px">-->
                        <!--                    <v-progress-linear-->
                        <!--                        v-model="percent"-->
                        <!--                        height="25"-->
                        <!--                    >-->
                        <!--                      <strong style="font-weight: bold;color: white">{{ Math.ceil(percent) }}%</strong>-->
                        <!--                    </v-progress-linear>-->
                        <!--                  </div>-->
                        <!--                      <v-card-text>-->
                        <!--                        <v-row>-->
                        <!--                          <v-col-->
                        <!--                            cols="12">-->
                        <!--                            <v-autocomplete-->
                        <!--                                v-model="posiCondi"-->
                        <!--                                :items="positions"-->
                        <!--                                item-text="PosName"-->
                        <!--                                item-value="PosCode"-->
                        <!--                                label="ตำแหน่ง"-->
                        <!--                                required-->
                        <!--                            ></v-autocomplete>-->
                        <!--                          </v-col>-->
                        <!--                        </v-row>-->
                        <!--                      </v-card-text>-->

                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red" v-if="!roundNeed"
                                 @click="backStep(6)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn text color="red" v-else
                                 @click="backStep(5)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(7)"
                              v-if="!roundNeed"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(6)"
                              v-else
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step editable :step="!roundNeed ? '8' : '7'">
                      พิจารณาโครงการ
                    </v-stepper-step>
                    <v-stepper-content :step="!roundNeed ? '8' : '7'">
                      <v-card style="border: 1px solid"
                              v-if="(Project.Approve == '1' && parseInt(Project.IsPlanStatus) >= 2 && HR) || (Project.Approve == '1' && parseInt(Project.IsPlanStatus) < 2) || (Project.Approve == '0')">
                        <v-toolbar
                            dark
                            color="primary">
                                                    <span>
                                                        พิจารณาโครงการ
                                                    </span>
                        </v-toolbar>
                        <v-list-item class="justify-center" style="margin-top: 30px">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="8">
                              <v-autocomplete
                                  outlined
                                  v-model="Approve_m"
                                  label="ผลการพิจารณา"
                                  :items="Approve_Status.filter(item => !item.disable)"
                                  item-text="detail"
                                  item-value="id"
                                  :error-messages="Approve_m == '' ? 'ผลการพิจารณา (ห้ามว่าง)' : ''"
                                  persistent-hint
                                  :error="Approve_m == ''"
                              >
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="8">
                              <v-textarea
                                  v-model="remarksApprove"
                                  outlined
                                  label="เหตุผล"
                              >
                              </v-textarea>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="8">
                              <v-text-field
                                  type="date"
                                  v-model="dateApprove"
                                  outlined
                                  label="วันที่พิจารณา"
                                  :error-messages="dateApprove == '' ? 'วันที่พิจารณา (ห้ามว่าง)' : ''"
                                  persistent-hint
                                  :error="dateApprove == ''"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="8">
                              <v-file-input
                                  v-model="files"
                                  color="deep-purple accent-4"
                                  counter
                                  label="ไฟล์แนบ"
                                  multiple
                                  placeholder="เลือกไฟล์"
                                  prepend-icon="mdi-paperclip"
                                  outlined
                                  :show-size="1000"
                                  @change="FileSelect"
                              >
                                <template v-slot:selection="{ index, text }">
                                  <v-chip
                                      v-if="index < 5"
                                      color="deep-purple accent-4"
                                      dark
                                      label
                                      small
                                  >
                                    {{ text }}
                                  </v-chip>

                                  <span
                                      v-else-if="index === 5"
                                      class="overline grey--text text--darken-3 mx-2"
                                  >
          +{{ files.length - 2 }} File(s)
        </span>
                                </template>
                              </v-file-input>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="8">
                              <v-alert
                                  v-if="alert"
                                  prominent
                                  type="error"
                              >
                                <v-row align="center" v-for="item in txtAlert"
                                       :key="item.id">
                                  <v-col class="d-flex grow">- {{ item.Detail }}
                                  </v-col>
                                </v-row>
                              </v-alert>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item v-if="File_Consider.length > 0">
                          <template>
                            <v-row>
                              <v-col cols="12" sm="6" offset-sm="3">
                                <v-card>
                                  <v-card-title>
                                    ไฟล์แนบประกอบ
                                  </v-card-title>
                                  <v-container fluid>
                                    <v-row>
                                      <v-col
                                          v-for="(file_i, index) in File_Consider"
                                          :key="index"
                                          class="d-flex child-flex"
                                          cols="12"
                                          md="4"
                                      >
                                        <v-card flat tile>
                                          <v-img
                                              v-if="file_i.type == 'image'"
                                              :src="file_i.src"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1"
                                              class="grey lighten-2"
                                          >
                                            <template
                                                v-slot:placeholder>
                                              <v-row
                                                  class="fill-height ma-0"
                                                  align="center"
                                                  justify="center"
                                              >
                                                <v-progress-circular
                                                    indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                              </v-row>
                                            </template>
                                          </v-img>
                                          <v-img
                                              v-if="file_i.type == 'pdf'"
                                              src="../assets/Image/pdf.png"
                                              :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                              aspect-ratio="1"
                                              class="grey lighten-2"
                                          >
                                            <template
                                                v-slot:placeholder>
                                              <v-row
                                                  class="fill-height ma-0"
                                                  align="center"
                                                  justify="center"
                                              >
                                                <v-progress-circular
                                                    indeterminate
                                                    color="grey lighten-5"></v-progress-circular>
                                              </v-row>
                                            </template>
                                          </v-img>
                                          <v-card-text>
                                                                          <span style="font-weight: bold;color: black">
                                                                              {{ file_i.name }}
                                                                          </span>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-btn text
                                                   @click="ShowData(file_i.src)">
                                                                              <span
                                                                                  style="color: indigo;font-weight: bold">
                                                                                  เรียกดู
                                                                              </span>
                                            </v-btn>
                                            <v-btn text
                                                   @click="DeleteFile(file_i)">
                                                                               <span
                                                                                   style="color: red;font-weight: bold">
                                                                                  ลบ
                                                                              </span>
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card>
                              </v-col>
                            </v-row>
                          </template>
                        </v-list-item>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                class="d-flex justify-center"
                                cols="6"
                                md="3">
                              <v-btn
                                  style="height: 55px"
                                  outlined
                                  color="primary"
                                  @click="(Approve_m == '' || dateApprove == '') ? showErrorConside() : ConsideProject()"
                              >
                                บันทึก
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row justify="center">
                            <v-col
                                cols="12"
                                md="12">
                              <span style="font-weight: bold">ประวัติการพิจารณาโครงการ</span>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row justify="center">
                            <v-col
                                cols="12"
                                md="12">
                              <v-list-item>
                                <v-expansion-panels popout>
                                  <v-expansion-panel
                                      v-for="(item,i) in RecordData"
                                      :key="i"
                                  >
                                    <v-expansion-panel-header>
                                      ประวัติการพิจารณาโครงการ
                                      วันที่พิจารณา
                                      <span
                                          style="color: #364eff;margin-left: 15px">{{
                                          item.Date_Approve | DateToThai
                                        }}</span>
                                      สถานะ :
                                      <v-chip
                                          v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                          :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                          style="transform: scale(0.8);color: white"
                                          class="d-flex justify-center"
                                      >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                      </v-chip>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <span class="d-flex">
                                        เหตุผล : {{ item.Remark }}
                                      </span>
                                      <div v-for="(file,idx) in item.files"
                                           v-bind:key="idx"
                                           style="color: #ff6d81">
                                        ไฟล์ประกอบ :
                                        <v-btn text
                                               @click="ShowData(Openfile + file.File_path)">
                                          {{ file.File_name }}
                                        </v-btn>
                                      </div>
                                      <template v-if="item.IsPlanStatus == '7'">
                                        <v-btn text @click="FormExpenses(item.Project_code)" color="primary">
                                          แบบฟอร์มเบิกค่าใช้จ่าย
                                        </v-btn>
                                      </template>
                                      <template v-else-if="item.IsPlanStatus == '5' && ApproveForm.length > 0">
                                        <v-btn v-if="Project.Approve != '0' && ApproveForm[0].IsPlanStatus == '3'"
                                               text @click="dialogFormConsideEdit = true" color="#9E9D24">
                                          แบบฟอร์มเบิกค่าใช้จ่าย (แก้ไข)
                                        </v-btn>
                                      </template>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-list-item>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-card>
                      <v-card v-else>
                        <v-toolbar
                            dark
                            :color="appColor">
                                                    <span>
                                                        พิจารณาโครงการ
                                                    </span>
                        </v-toolbar>
                        <v-list-item class="justify-center">
                          <v-row justify="center">
                            <v-col
                                cols="12"
                                md="12">
                              <span style="font-weight: bold">ประวัติการพิจารณาโครงการ</span>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-row justify="center">
                            <v-col
                                cols="12"
                                md="12">
                              <v-list-item>
                                <v-expansion-panels popout>
                                  <v-expansion-panel
                                      v-for="(item,i) in RecordData"
                                      :key="i"
                                  >
                                    <v-expansion-panel-header>
                                      ประวัติการพิจารณาโครงการ
                                      วันที่พิจารณา
                                      <span
                                          style="color: #364eff;margin-left: 15px">{{
                                          item.Date_Approve | DateToThai
                                        }}</span>
                                      สถานะ :
                                      <v-chip
                                          color="#6D4C41"
                                          style="transform: scale(0.8)"
                                          v-if="item.IsPlanStatus == '1'"
                                          class="d-flex justify-center"
                                      >
                                        <span style="color: white;font-weight: bold">รอพิจารณา</span>
                                      </v-chip>
                                      <v-chip
                                          color="#00BFA5"
                                          style="transform: scale(0.8);color: white"
                                          v-if="item.IsPlanStatus == '2'"
                                      >
                                        <span style="color: white;font-weight: bold" v-if="Project.Approve == '0'">อนุมัติ</span>
                                        <span style="color: white;font-weight: bold" v-else>อนุมัติ(หน่วยงาน)</span>
                                      </v-chip>
                                      <v-chip
                                          color="#F50057"
                                          style="transform: scale(0.8)"
                                          v-else-if="item.IsPlanStatus == '3'"
                                          class="d-flex justify-center"
                                      >
                                        <span style="color: white;font-weight: bold">ไม่อนุมัติ</span>
                                      </v-chip>
                                      <v-chip
                                          color="#C0CA33"
                                          style="transform: scale(0.8)"
                                          v-else-if="item.IsPlanStatus == '4'"
                                          class="d-flex justify-center"
                                      >
                                        <span style="color: white;font-weight: bold">แก้ไข</span>
                                      </v-chip>
                                      <v-chip
                                          color="#00B8D4"
                                          style="transform: scale(0.8)"
                                          v-else-if="item.IsPlanStatus == '5'"
                                          class="d-flex justify-center"
                                      >
                                        <span style="color: white;font-weight: bold">เสนอพิจารณา</span>
                                      </v-chip>
                                      <v-chip
                                          color="#76FF03"
                                          style="transform: scale(0.8)"
                                          v-else-if="item.IsPlanStatus == '6'"
                                          class="d-flex justify-center"
                                      >
                                        <span style="color: white;font-weight: bold">อนุมัติ(ขั้นต้น)</span>
                                      </v-chip>
                                      <v-chip
                                          color="#00C853"
                                          style="transform: scale(0.8)"
                                          v-else-if="item.IsPlanStatus == '7'"
                                          class="d-flex justify-center"
                                      >
                                        <span style="color: white;font-weight: bold">อนุมัติ(คณะ)</span>
                                      </v-chip>
                                      <v-chip
                                          color="primary"
                                          style="transform: scale(0.8)"
                                          class="d-flex justify-center"
                                          v-else
                                      >
                                        <span style="color: white;font-weight: bold">ยกเลิกโครงการ</span>
                                      </v-chip>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <span class="d-flex">
                                        เหตุผล : {{ item.Remark }}
                                      </span>
                                      <div v-for="(file,idx) in item.files"
                                           v-bind:key="idx"
                                           style="color: #ff6d81">
                                        ไฟล์ประกอบ :
                                        <v-btn text
                                               @click="ShowData(Openfile + file.File_path)">
                                          {{ file.File_name }}
                                        </v-btn>
                                      </div>
                                      <template v-if="item.IsPlanStatus == '7'">
                                        <v-btn text @click="FormExpenses(item.Project_code)" color="primary">
                                          แบบฟอร์มเบิกค่าใช้จ่าย
                                        </v-btn>
                                      </template>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-list-item>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-card>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red"
                               @click="backStep(7)" v-if="!roundNeed">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn text color="red"
                               @click="backStep(6)" v-else>
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                      </v-list-item>
                    </v-stepper-content>
                  </template>
                </v-stepper>
              </template>
              <template v-else-if="Process == '2'">
                <v-stepper
                    v-model="e1"
                    :vertical="vertical"
                    :alt-labels="altLabels"
                >
                  <v-stepper-step editable step="1">
                    <span
                        style="font-weight: bold">{{
                        ((Project != null && Project.Project_type == '1') ? 'ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี' : 'ข้อมูลการอบรม / เดินทางไปปฏิบัติงาน')
                      }}</span>
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-row>
                          <v-col
                              cols="12"
                              md="12">
                            <h2 class="font-weight-bold" style="color: #ff6d81">รายละเอียด</h2>
                            <v-list-item style="margin-top: 20px;width: 100%" v-if="Project != null">
                              <v-row>
                                <v-divider vertical></v-divider>
                                <v-col
                                    cols="12"
                                    md="5">
                                  <p class="font-weight-bold" style="color: blue">หน่วยงาน:
                                    <span style="color: black">{{
                                        depart.filter(item => item.dep_id == Project.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == Project.Dep_Code)[0].dep_name : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ข้อมูลประจำปี:
                                    <span style="color: black">{{
                                        parseInt(Project.FiscalYear) + 543
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="Project.Project_type == '2'">
                                    <p class="font-weight-bold" style="color: blue">
                                      ประเภททำรายการ:
                                      <span style="color: black">{{
                                          Project.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : Project.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                    <p class="font-weight-bold" style="color: blue">
                                      ประเภทค่าใช้จ่าย:
                                      <span style="color: black">{{
                                          Project.IsExpense == '1' ? 'มีค่าใช้จ่าย' : Project.IsExpense == '0' ? 'ไม่มีค่าใช้จ่าย' : '-'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                    <p class="font-weight-bold" style="color: blue">
                                      ประเภทการไปปฏิบัติราชการ:

                                      <span style="color: black">{{
                                          projectGroup.filter(item => item.Project_group == Project.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project.Project_group)[0].Project_group_des : '-'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">หมวด:
                                    <span style="color: black">{{
                                        Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="Project.Project_type == '1'">
                                    <p class="font-weight-bold" style="color: blue">ประเภทแผน:
                                      <span style="color: black">{{
                                          Project.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <template v-if="Project.Project_type == '1'">
                                    <template v-if="episode == '1'">
                                      <p class="font-weight-bold" style="color: blue">ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '2'">
                                      <p class="font-weight-bold" style="color: blue">
                                        ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '3'">
                                      <p class="font-weight-bold" style="color: blue">
                                        ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '4'">
                                      <p class="font-weight-bold" style="color: blue">
                                        ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '9'">
                                      <p class="font-weight-bold" style="color: blue">ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                  </template>
                                  <template v-else-if="Project.Project_type == '2'">
                                    <p class="font-weight-bold" style="color: blue">วันที่จัด:
                                      <span style="color: black" v-if="Project.DateStart == Project.DateEnd">{{
                                          Project.DateStart | dateToThai
                                        }}</span>
                                      <span style="color: black" v-else>{{
                                          Project.DateStart | dateToThai
                                        }} - {{
                                          Project.DateEnd | dateToThai
                                        }}</span>
                                    </p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">รหัสอบรม/เดินทาง: <span
                                      style="color: black">{{ Project.Project_code }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ชื่องาน / กิจจกรม:
                                    <span style="color: black">{{
                                        Project.Project_name
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">
                                    {{ Project.Project_type == '1' ? 'ประเภทแผน' : 'ประเภทการไปปฏิบัติราชการ' }}:
                                    <span style="color: black">{{
                                        projectGroup.filter(item => item.Project_group == Project.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project.Project_group)[0].Project_group_des : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">หลักสูตร:
                                    <span style="color: black">{{
                                        courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project.Course_code)[0].Course_name : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">สาขาประเภทหลักสูตร:
                                    <span style="color: black">{{
                                        courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project.Course_code)[0].Course_type_des : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ระยะเวลา:
                                    <span style="color: black">{{
                                        courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project.Course_code)[0].Period_code)[0].name : '-' : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col
                                    cols="12"
                                    md="5">
                                  <p class="font-weight-bold" style="color: blue">จำนวน ช.ม.: <span
                                      style="color: black">{{ Project.CalHourse }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">จำนวน เครดิต: <span
                                      style="color: black">{{ Project.CalCredit }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">งบประมาณที่ขอ: <span
                                      style="color: black">{{ Project.BudgetRequest | currency }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">งานถูกจัดขึ้น: <span
                                      style="color: black">{{
                                      PLACESelete.filter(item => item.id == Project.PLACE).length > 0 ? PLACESelete.filter(item => item.id == Project.PLACE)[0].detail : '-'
                                    }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="Project.PLACE == '2'">
                                    <p class="font-weight-bold" style="color: blue">จังหวัด: <span style="color: black">{{
                                        provinces_Data.filter(item => item.code == Project.Province_id).length > 0 ? provinces_Data.filter(item => item.code == Project.Province_id)[0].name_th : '-'
                                      }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <template v-else-if="Project.PLACE == '3'">
                                    <p class="font-weight-bold" style="color: blue">ประเทศ: <span style="color: black">{{
                                        countryData.filter(item => item.ct_code == Project.Country_id).length > 0 ? countryData.filter(item => item.ct_code == Project.Country_id)[0].ct_nameTHA : '-'
                                      }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">จัดโดย:
                                    <span style="color: black">{{
                                        WorkByData.filter(item => item.id == Project.WorkBy).length > 0 ? WorkByData.filter(item => item.id == Project.WorkBy)[0].detail : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ชื่อผู้จัด: <span
                                      style="color: black">{{ Project.WorkByName }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">เบอร์โทรติดต่อผู้กรอกข้อมูล:
                                    <span style="color: black">{{ Project.WorkByPhone }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">สถานที่จัด: <span
                                      style="color: black">{{ Project.Location }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="Project.Project_type == '1'">
                                    <p class="font-weight-bold" style="color: blue">กลุ่มเป้าหมาย: <span
                                        style="color: black">{{ Project.TargetGroup }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                    <p class="font-weight-bold" style="color: blue">วัตถุประสงค์: <span
                                        style="color: black">{{ Project.Objective }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">รายละเอียดประกอบ (เพิ่มเติม):
                                    <span style="color: black">{{ Project.Remarks }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">Competency,Core Value,Strategic
                                    Objective:
                                    <v-btn text color="primary" @click="showTravelCompetency(Project)">คลิก!!</v-btn>
                                  </p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ไฟล์เอกสารประกอบ:
                                    <v-btn text color="primary" @click="showFile()">คลิก!!</v-btn>
                                  </p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="Project.Project_type == '2'">
                                    <p class="font-weight-bold" style="color: blue" v-if="Project.Project_type == '2'">
                                      ผู้เข้าร่วมจำนวน {{ JoinTravel.length }} คน:
                                      <v-btn text color="primary" v-if="JoinTravel.length > 0"
                                             @click="showJoinTravel()">คลิก!!
                                      </v-btn>
                                    </p>
                                    <p class="font-weight-bold" style="color: blue" v-if="Project.Project_type == '2'">
                                      เอกสารแบบฟอร์มเสนอ (จากระบบ):
                                      <v-btn text color="primary" @click="showFileReport(Project)">คลิก!!</v-btn>
                                    </p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item>
                              <p class="mt-8" style="font-weight: bold">
                                <span v-if="Project.Project_type == '1'">วันที่บันทึกข้อมูลแผน:</span>
                                <span v-else-if="Project.Project_type == '2'">วันที่บันทึกข้อมูล:</span>
                                {{ Project.Create_Time | dateToThai2 }}</p>
                            </v-list-item>
                            <v-list-item>
                              <p style="font-weight: bold">สถานะแผน:
                                <v-chip
                                    v-if="StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus).length > 0"
                                    :color="StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus)[0].color : ''"
                                    style="transform: scale(0.8);color: white"
                                >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == Project.IsPlanStatus)[0].status : ''
                              }}</span>
                                </v-chip>
                              </p>
                            </v-list-item>
                            <v-list-item
                                v-if="parseInt(Project.IsPlanStatus) >= 6 && parseInt(Project.IsPlanStatus) <= 9">
                              <hr class="mb-2 mt-2"/>
                              <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                อนุมัติวงเงิน : {{ Project.BudgetArrove | currency }} บาท
                              </span>
                            </v-list-item>
                            <v-list-item
                                v-if="parseInt(Project.IsPlanStatus) >= 6 && parseInt(Project.IsPlanStatus) <= 9">
                              <hr class="mb-2 mt-2"/>
                              <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                จำนวนเงินเบิกจ่าย : {{ Project.MoneyDisburse | currency }} บาท
                              </span>
                            </v-list-item>
                          </v-col>
                          <v-divider vertical></v-divider>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                    </v-list-item>
                  </v-stepper-content>
                  <template
                      v-if="(Project.IsPlanStatus != '0' && Project.IsPlanStatus != '4' && Project.IsPlanStatus != '8' && Project.IsPlanStatus != '9')">
                    <v-stepper-step step="2" editable>
                        <span
                            class="font-weight-bold">พิจารณา อบรม / เดินทางไปปฏิบัติงาน</span>
                    </v-stepper-step>
                    <v-stepper-content step="2">
                      <v-card style="border: 1px solid">
                        <v-toolbar
                            dark
                            :color="appColor">
                          <span>พิจารณา อบรม / เดินทางไปปฏิบัติงาน</span>
                        </v-toolbar>
                        <template v-if="Approve_Status.filter(item => !item.disable).length > 0">
                          <v-list-item class="justify-center" style="margin-top: 30px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="8">
                                <v-autocomplete
                                    outlined
                                    v-model="Approve_m"
                                    label="ผลการพิจารณา"
                                    :items="Approve_Status.filter(item => !item.disable)"
                                    item-text="detail"
                                    item-value="id"
                                    :error-messages="Approve_m == null ? 'ผลการพิจารณา (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    :error="Approve_m == null"
                                >
                                </v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <!--                    <v-list-item class="justify-center" v-if="Approve_m == '0'">
                                                <v-row class="d-flex justify-center">
                                                  &lt;!&ndash;                              <v-col&ndash;&gt;
                                                  &lt;!&ndash;                                  cols="12"&ndash;&gt;
                                                  &lt;!&ndash;                                  md="4">&ndash;&gt;
                                                  &lt;!&ndash;                                <v-text-field&ndash;&gt;
                                                  &lt;!&ndash;                                    v-model="App_doc_no"&ndash;&gt;
                                                  &lt;!&ndash;                                    outlined&ndash;&gt;
                                                  &lt;!&ndash;                                    label="หนังสือเลขที่อนุมัติหลักการ"&ndash;&gt;
                                                  &lt;!&ndash;                                >&ndash;&gt;
                                                  &lt;!&ndash;                                </v-text-field>&ndash;&gt;
                                                  &lt;!&ndash;                              </v-col>&ndash;&gt;
                                                  <v-col
                                                      cols="12"
                                                      md="8">
                                                    <v-text-field
                                                        v-model="BudgetArrove"
                                                        outlined
                                                        label="จำนวนเงินที่อนุมัติ"
                                                    >
                                                    </v-text-field>
                                                  </v-col>
                                                </v-row>
                                              </v-list-item>-->
                          <v-list-item class="justify-center">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="8">
                                <v-textarea
                                    v-model="remarksApprove"
                                    outlined
                                    label="เหตุผล"
                                >
                                </v-textarea>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="8">
                                <v-text-field
                                    type="date"
                                    v-model="dateApprove"
                                    outlined
                                    label="วันที่พิจารณา"
                                    :error-messages="dateApprove == '' ? 'วันที่พิจารณา (ห้ามว่าง)' : ''"
                                    persistent-hint
                                    :error="dateApprove == ''"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="8">
                                <v-file-input
                                    v-model="files"
                                    color="deep-purple accent-4"
                                    counter
                                    label="ไฟล์แนบ"
                                    multiple
                                    placeholder="เลือกไฟล์"
                                    prepend-icon="mdi-paperclip"
                                    outlined
                                    :show-size="1000"
                                    @change="FileSelect"
                                >
                                  <template v-slot:selection="{ index, text }">
                                    <v-chip
                                        v-if="index < 5"
                                        color="deep-purple accent-4"
                                        dark
                                        label
                                        small
                                    >
                                      {{ text }}
                                    </v-chip>

                                    <span
                                        v-else-if="index === 5"
                                        class="overline grey--text text--darken-3 mx-2"
                                    >
          +{{ files.length - 2 }} File(s)
        </span>
                                  </template>
                                </v-file-input>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item class="justify-center">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="8">
                                <v-alert
                                    v-if="alert"
                                    prominent
                                    type="error"
                                >
                                  <v-row align="center" v-for="item in txtAlert"
                                         :key="item.id">
                                    <v-col class="d-flex grow">- {{ item.Detail }}
                                    </v-col>
                                  </v-row>
                                </v-alert>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="File_Consider.length > 0">
                            <template>
                              <v-row>
                                <v-col cols="12" sm="6" offset-sm="3">
                                  <v-card>
                                    <v-card-title>
                                      ไฟล์แนบประกอบ
                                    </v-card-title>
                                    <v-container fluid>
                                      <v-row>
                                        <v-col
                                            v-for="(file_i, index) in File_Consider"
                                            :key="index"
                                            class="d-flex child-flex"
                                            cols="12"
                                            md="4"
                                        >
                                          <v-card flat tile>
                                            <v-img
                                                v-if="file_i.type == 'image'"
                                                :src="file_i.src"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template
                                                  v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-if="file_i.type == 'pdf'"
                                                src="../assets/Image/pdf.png"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template
                                                  v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-card-text>
                                                                          <span
                                                                              style="font-weight: bold;color: black">
                                                                              {{ file_i.name }}
                                                                          </span>
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-btn text
                                                     @click="ShowData(file_i.src)">
                                                                              <span
                                                                                  style="color: indigo;font-weight: bold">
                                                                                  เรียกดู
                                                                              </span>
                                              </v-btn>
                                              <v-btn text
                                                     @click="DeleteFile(idx)">
                                                                               <span
                                                                                   style="color: red;font-weight: bold">
                                                                                  ลบ
                                                                              </span>
                                              </v-btn>
                                            </v-card-actions>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list-item>
                          <v-list-item>
                            <v-row class="d-flex justify-center">
                              <v-col
                                  class="d-flex justify-center"
                                  cols="6"
                                  md="3">
                                <v-btn
                                    style="height: 55px"
                                    outlined
                                    color="primary"
                                    @click="ConsideProject"
                                >
                                  บันทึก
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </template>
                        <template v-else>
                          <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                            คุณไม่ได้รับสิทธิ์ในการพิจารณาข้อมูลอบรม / เดินทางไปปฏิบัติงาน !!</p>
                        </template>
                        <v-list-item class="justify-center">
                          <v-row justify="center">
                            <v-col
                                cols="12"
                                md="12">
                              <span style="font-weight: bold">ประวัติการพิจารณา</span>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <template v-if="RecordDataDump.length > 0">
                          <v-list-item class="justify-center">
                            <v-row justify="center">
                              <v-col
                                  cols="12"
                                  md="12">
                                <v-list-item>
                                  <v-expansion-panels popout>
                                    <v-expansion-panel
                                        v-for="(item,i) in RecordDataDump"
                                        :key="i"
                                    >
                                      <v-expansion-panel-header>
                                          <span
                                              style="color: #364eff;margin-left: 15px;font-weight: bold">{{
                                              item.Date_Approve | DateToThai
                                            }}</span><span
                                          style="font-weight: bold;color: blue">( {{
                                          (item.Type == '1' ? 'คณะ' : item.Type == '2' ? 'หน่วยงาน' : 'ผู้มีอำนาจ(หน่วยงาน)')
                                        }} )</span>
                                        สถานะ :
                                        <v-chip
                                            v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                            :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                            style="transform: scale(0.8);color: white"
                                            class="d-flex justify-center"
                                        >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                        </v-chip>
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content v-if="item.Status != '1'">
                                        <p>
                                          เหตุผล : {{ item.Remark }}
                                        </p>
                                        <div v-for="(file,idx) in item.files"
                                             v-bind:key="idx"
                                             style="color: #ff6d81">
                                          ไฟล์ประกอบ :
                                          <v-btn text
                                                 @click="ShowData(Openfile + file.File_path)">
                                            {{ file.File_name }}
                                          </v-btn>
                                        </div>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-list-item>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </template>
                        <template v-else>
                          <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                            ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                        </template>
                      </v-card>
                    </v-stepper-content>
                  </template>
                </v-stepper>
              </template>
            </v-card>
          </v-container>
        </v-card>
      </template>
      <template v-else>
        <v-card>
          <v-card-text>
            <v-responsive class="justify-center align-center text-center" height="500px">
                      <span style="font-size: 50px;font-weight: bold">
                        คุณไม่ได้รับสิทธิ์การใช้งาน
                      </span>
            </v-responsive>
          </v-card-text>
        </v-card>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร/คณะกรรมการ/นำเสนอผลงาน</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{
                          file.File_name
                        }}
                      </v-btn>
                    </div>
                    <div>
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_travel_start="{item}">
                <span v-if="item.date_travel_start != '0000-00-00' && item.date_travel_start != null">{{
                    item.date_travel_start | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.date_travel_end="{item}">
                <span v-if="item.date_travel_end != '0000-00-00' && item.date_travel_end != null">{{
                    item.date_travel_end | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.date_start="{item}">
                <span v-if="item.date_start != '0000-00-00' && item.date_start != null">{{
                    item.date_start | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.date_end="{item}">
                <span v-if="item.date_end != '0000-00-00' && item.date_end != null">{{
                    item.date_end | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.time_start="{item}">
                  <span v-if="item.time_start != '00:00:00' && item.time_start != null">{{ item.time_start }}</span>
                </template>
                <template v-slot:item.time_end="{item}">
                  <span v-if="item.time_end != '00:00:00' && item.time_end != null">{{ item.time_end }}</span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogRound"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar
              dark
              color="primary"
              dense fixed
          >
            <v-btn
                icon
                dark
                @click="dialogRound = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>กำหนดรุ่นการจัดโครงการ</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="dialogRound = false"
              >
                ยกเลิก
              </v-btn>
            </v-toolbar-items>
          </v-app-bar>
          <v-row class="d-flex justify-center mt-10">
            <v-col
                cols="12"
                md="8">
              <v-tabs
                  color="red darken-3"
                  show-arrows
                  v-model="tabs"
              >
                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                <v-tab
                    key="CoriTab"
                >
                  รุ่น/กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วมโครงการ
                </v-tab>
                <v-tab
                    key="JoinTab"
                >
                  ผู้เข้าร่วมโครงการ
                  <v-chip color="red" dark class="ml-3">
                    {{ JoinPerson.length }}
                  </v-chip>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs">
                <v-tab-item
                    key="CoriTab"
                >
                  <v-list>
                    <v-list-item-title class="headline mb-1">
                      รุ่นโครงการ
                    </v-list-item-title>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>รุ่นที่</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span> : {{ round }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>ชื่อรุ่น</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span> : {{ round_name }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เริ่มต้น</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="dateRegS != '' && dateRegS != '0000-00-00'"> : {{ dateRegS | dateToThai }}</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่สิ้นสุด</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="dateRegE != '' && dateRegE != '0000-00-00'"> : {{ dateRegE | dateToThai }}</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>เวลาเริ่มต้น</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="time_start != '00:00:00'"> : {{ time_start }} น.</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>เวลาสิ้นสุด</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="time_end != '00:00:00'"> : {{ time_end }} น.</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item-title class="headline mt-6"><span>กลุ่มเป้าหมาย</span>
                    </v-list-item-title>
                    <v-list-item class="d-flex justify-center">
                      <v-data-table
                          :headers="dataHeadersCondi"
                          :items="DataCondi"
                          :search="search"
                          item-key="PosWork"
                          class="elevation-1 mt-4"
                          v-if="DataCondi.length > 0"
                      >
                        <template v-slot:header.PosName>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            เงื่อนไขตำแหน่ง, อายุงาน
                          </v-label>
                        </template>
                        <template v-slot:header.Level>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ระดับ
                          </v-label>
                        </template>
                        <template v-slot:header.workAgeStart>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อายุงานเริ่มต้น
                          </v-label>
                        </template>
                        <template v-slot:header.workAgeEnd>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อายุงานสิ้นสุด
                          </v-label>
                        </template>
                        <template v-slot:item.PosName="{ item }">
                          <v-label>
                            {{ item.PosName }}
                          </v-label>
                        </template>
                        <template v-slot:item.Level="{ item }">
                          <v-label>
                            {{ item.Level }}
                          </v-label>
                        </template>
                        <template
                            v-slot:item.workAgeStart="{ item }">
                          <v-label>
                            {{ item.workAgeStart }} (ปี)
                          </v-label>
                        </template>
                        <template v-slot:item.workAgeEnd="{ item }">
                          <v-label>
                            {{ item.workAgeEnd }} (ปี)
                          </v-label>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-row class="d-flex">
                            <v-col
                                cols="6"
                                md="6">
                              <v-btn
                                  outlined
                                  color="#BF360C"
                                  @click="DeleteDataCondi(item)">
                                ลบ
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-list-item>
                    <v-divider class="mt-6"></v-divider>
                    <v-list-item-title class="headline mt-6">
                      เงื่อนไขการเข้าร่วมโครงการ
                    </v-list-item-title>
                    <v-list-item>
                      <v-list-item-subtitle>
                        สถานะสมัครเข้าร่วมโครงการ
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>การเปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="ChooseTypRegis == '0'"> : อนุญาตสมัครเข้าร่วมโครงการ</span>
                          <span v-else> : ไม่อนุญาตสมัครเข้าร่วมโครงการ</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center" v-if="ChooseTypRegis == '0'">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>อนุญาตให้สมัครเฉพาะ</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="ChooseTypRegis2 == '0'"> : หน่วยงานและบุคลากรทั่วไป</span>
                          <span v-else-if="ChooseTypRegis2 == '1'"> : หน่วยงาน</span>
                          <span v-else> : บุคลากรทั่วไป</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                        <span v-if="ChooseTypRegis == '0' && (dateRegStart != '0000-00-00' && dateRegStart != null)"> : {{
                            dateRegStart | dateToThai
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                        <span
                            v-if="ChooseTypRegis == '0' && (dateRegEnd != '0000-00-00' && dateRegEnd != null)"> : {{
                            dateRegEnd | dateToThai
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        ผู้เข้าร่วมโครงการ
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>จำกัดจำนวนผู้เข้าร่วมโครงการ</span>
                        </v-col>
                        <v-col
                            md="4"
                            cols="12">
                        <span
                            v-if="ProjectQuotaCount != '' && ProjectQuotaCount != null && ProjectQuotaCount != '0'"> : {{
                            ProjectQuotaCount
                          }} คน</span>
                          <span v-else> : ไม่จำกัด</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        โควตาหน่วยงานที่เข้าร่วม
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-data-table
                          :headers="DepQuotaHeader"
                          :items="DepQuotaData"
                          :search="searchDepQuota"
                          class="elevation-1 mt-4"
                      >
                        <template v-slot:header.type>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ประเภท
                          </v-label>
                        </template>
                        <template v-slot:header.dep_name>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ภาควิชา/หน่วยงาน
                          </v-label>
                        </template>
                        <template v-slot:header.count>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            จำนวน/คน
                          </v-label>
                        </template>
                        <template
                            v-slot:footer
                        >
                          <template>
                            <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                            </div>
                            <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(ProjectQuotaCount) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                            </div>
                            <div align="center" v-else>
                              <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                            </div>
                            <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  ProjectQuotaCount
                                }} คน</span>
                            </div>
                            <div align="center" v-else>
                              <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                            </div>
                          </template>
                        </template>
                      </v-data-table>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item
                    key="JoinTab"
                >
                  <v-card class="mt-7">
                    <v-toolbar
                        color="primary"
                        dark
                        flat
                    >
                      <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการ {{ JoinPerson.length }} <span
                          v-if="!ChkJoinPerson"> / {{ ProjectQuotaCount }}</span> คน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="searchPerson"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          v-if="JoinPerson.length > 0"
                      ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headersPerson"
                        :items="JoinPerson"
                        :search="searchPerson"
                        v-if="JoinPerson.length > 0"
                    >
                      <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                        <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                        <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                        <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                        <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                        <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                      </template>
                      <template v-slot:item.status_reg="{item}">
                              <span style="font-weight: bold;color: #364eff"
                                    v-if="item.status_reg == '1'">ลงทะเบียน</span>
                        <span style="font-weight: bold;color: #ffd54f" v-else>รอลงทะเบียน</span>
                      </template>
                      <template v-slot:item.action="{item}">
                        <v-btn
                            color="#F44336"
                            outlined
                            @click="Del_item(item)">
                          ลบ
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogFormConside"
          scrollable
          width="800"
      >
        <v-card>
          <v-card-title>
            <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12">
                <v-card>
                  <v-card-title class="font-weight-bold justify-center">
                    <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
                  </v-card-title>
                  <v-card-text>
                    <list>
                      <v-list-item class="font-weight-bold">
                        <span style="font-size: 16px">เรียน  รองคณบดีฝ่ายทรัพยากรมนุษย์</span>
                      </v-list-item>
                      <v-list-item>
                        <v-textarea label="ข้อความ" outlined v-model="messageFormApprove"
                                    :error="messageFormApprove == ''"
                                    :error-messages="messageFormApprove == '' ? 'ข้อความ (ห้ามว่าง)' : ''"></v-textarea>
                      </v-list-item>
                      <v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="6">
                            <v-autocomplete
                                v-model="peridToName"
                                :items="staffData"
                                item-text="custom_Detail"
                                item-value="perid"
                                outlined
                                label="ตัวเลือกบุคลากร"
                                @change="get_full_Name"
                                clearable
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              md="6">
                            <v-text-field outlined label="ชื่อ - สกุล" v-model="full_NameFormApprove"
                                          :error="full_NameFormApprove == ''"
                                          :error-messages="full_NameFormApprove == '' ? 'ชื่อ - สกุล (ห้ามว่าง)' : ''"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="6">
                            <v-autocomplete
                                v-model="positionToName"
                                :items="positions"
                                item-text="PosName"
                                item-value="PosCode"
                                outlined
                                label="ตัวเลือกตำแหน่ง"
                                @change="get_Position"
                                clearable
                            ></v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              md="6">
                            <v-text-field outlined label="ตำแหน่ง" v-model="positionFormApprove"
                                          :error="positionFormApprove == ''"
                                          :error-messages="positionFormApprove == '' ? 'ตำแหน่ง' : ''"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="font-weight-bold">
                        <v-spacer></v-spacer>
                        <span style="font-size: 16px">
                                  {{ new Date().getDate() }} / {{
                            new Date().getMonth() + 1
                          }} / {{ new Date().getFullYear() + 543 }}
                                </span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                      <span
                          style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 200px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                      <span
                          style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 80px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 120px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>

                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(................../........................./.....................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(................../........................../....................)</span>
                      </v-list-item>
                    </list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="green" @click="ConsideProject">บันทึก</v-btn>
            <v-btn outlined color="red" @click="dialogFormConside = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="dialogFormConsideEdit"
          scrollable
          width="800"
      >
        <v-card>
          <v-card-title>
            <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col
                  cols="12">
                <v-card>
                  <v-card-title class="font-weight-bold justify-center">
                    <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
                  </v-card-title>
                  <v-card-text>
                    <list>
                      <v-list-item class="font-weight-bold">
                        <span style="font-size: 16px">เรียน  รองคณบดีฝ่ายทรัพยากรมนุษย์</span>
                      </v-list-item>
                      <v-list-item>
                        <v-textarea label="ข้อความ" outlined v-model="messageFormApprove"
                                    :error="messageFormApprove == ''"
                                    :error-messages="messageFormApprove == '' ? 'ข้อความ (ห้ามว่าง)' : ''"></v-textarea>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field outlined label="ชื่อ - สกุล" v-model="full_NameFormApprove"
                                      :error="full_NameFormApprove == ''"
                                      :error-messages="full_NameFormApprove == '' ? 'ชื่อ - สกุล (ห้ามว่าง)' : ''"></v-text-field>
                      </v-list-item>
                      <v-list-item>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field outlined label="ตำแหน่ง" v-model="positionFormApprove"
                                      :error="positionFormApprove == ''"
                                      :error-messages="positionFormApprove == '' ? 'ตำแหน่ง' : ''"></v-text-field>
                      </v-list-item>
                      <v-list-item class="font-weight-bold">
                        <v-spacer></v-spacer>
                        <span style="font-size: 16px">
                                  {{ new Date().getDate() }} / {{
                            new Date().getMonth() + 1
                          }} / {{ new Date().getFullYear() + 543 }}
                                </span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                      <span
                          style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 200px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                      <span
                          style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 80px">อนุมัติ</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(........................................................................)</span>
                      </v-list-item>
                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 120px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(ผศ.นพ.เทอดพงศ์ ทองศรีราช)</span>
                      </v-list-item>

                      <v-list-item class="d-lg-flex d-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 110px">(................../........................./.....................)</span>
                      </v-list-item>
                      <v-list-item class="d-md-flex d-lg-none justify-end">
                        <span style="font-weight: bold;font-size: 16px;text-align: center;margin-right: 0px">(................../........................../....................)</span>
                      </v-list-item>
                    </list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="#9E9D24" @click="EditFormConside">แก้ไข</v-btn>
            <v-btn outlined color="red" @click="dialogFormConsideEdit = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template>
        <v-dialog
            v-model="dialogApproveForm"
            scrollable
            fullscreen
        >
          <v-card>
            <v-card-title>
              <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
            </v-card-title>
            <v-card-text v-if="ApproveForm.length > 0 && ProjectRecord.length > 0">
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                >
                  <v-card>
                    <v-card-title class="font-weight-bold justify-center">
                      <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col
                            cols="12"
                            md="6"
                        >
                          <list>
                            <v-list-item class="font-weight-bold">
                              <p style="font-size: 28px;font-weight: bold">เรียน รองคณบดีฝ่ายทรัพยากรมนุษย์</p>
                            </v-list-item>
                            <v-list-item>
                              <p style="font-size: 24px;text-align: left;margin-left: 30px">
                                {{ ApproveForm[0].message }}</p>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <p style="font-size: 24px;text-align: right">{{ ApproveForm[0].name }}</p>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <p style="font-size: 24px;text-align: right">{{ ApproveForm[0].position }}</p>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <p style="font-size: 24px;text-align: right">
                                {{ ApproveForm[0].create_time.split(' ')[0].split('-')[2] }} /
                                {{ ApproveForm[0].create_time.split(' ')[0].split('-')[1] }} /
                                {{ (parseInt(ApproveForm[0].create_time.split(' ')[0].split('-')[0]) + 543) }}
                              </p>
                            </v-list-item>
                            <v-list-item class="d-lg-flex d-none justify-end mt-6">
                              <p
                                  style="font-weight: bold;font-size: 24px;text-align: center;margin-right: 185px">
                                อนุมัติ</p>
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end mt-6">
                              <p
                                  style="font-weight: bold;font-size: 24px;text-align: center;margin-right: 88px">
                                อนุมัติ</p>
                            </v-list-item>
                            <v-list-item class="d-lg-flex d-none justify-end mt-10">
                              <img src="../assets/Image/license_or_thred.png" height="50"
                                   style="position: absolute;top: -36px;right: 83px">
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                              <img src="../assets/Image/license_or_thred.png" height="50"
                                   style="position: absolute;top: -36px;right: -16px">
                            </v-list-item>
                            <v-list-item class="d-lg-flex d-none justify-end">
                              <p style="font-size: 24px;text-align: center;margin-right: 124px">(ผศ.นพ.เทอดพงศ์
                                ทองศรีราช)</p>
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end">
                              <p style="font-size: 24px;text-align: center;margin-right: 21px">(ผศ.นพ.เทอดพงศ์
                                ทองศรีราช)</p>
                            </v-list-item>

                            <v-list-item class="d-lg-flex d-none justify-end">
                              <p style="font-size: 24px;text-align: center;margin-right: 160px">
                                {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end">
                              <p style="font-size: 24px;text-align: center;margin-right: 64px">
                                {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                            </v-list-item>
                          </list>
                        </v-col>
                      </v-row>
                      <v-container v-show="false">
                        <v-row id="FormExpensesPrintData">
                          <v-col
                              cols="6"
                              md="12"
                          >
                            <list>
                              <v-list-item class="font-weight-bold">
                                <p style="font-size: 28px;font-weight: bold">เรียน รองคณบดีฝ่ายทรัพยากรมนุษย์</p>
                              </v-list-item>
                              <v-list-item>
                                <p style="font-size: 24px;text-align: left;margin-left: 30px">
                                  {{ ApproveForm[0].message }}</p>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <p style="font-size: 24px;text-align: right">{{ ApproveForm[0].name }}</p>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <p style="font-size: 24px;text-align: right">{{ ApproveForm[0].position }}</p>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <p style="font-size: 24px;text-align: right">
                                  {{ ApproveForm[0].create_time.split(' ')[0].split('-')[2] }} /
                                  {{ ApproveForm[0].create_time.split(' ')[0].split('-')[1] }} /
                                  {{ (parseInt(ApproveForm[0].create_time.split(' ')[0].split('-')[0]) + 543) }}
                                </p>
                              </v-list-item>
                              <v-list-item class="d-lg-flex d-none justify-end mt-6">
                                <p
                                    style="font-weight: bold;font-size: 24px;text-align: center;margin-right: 185px">
                                  อนุมัติ</p>
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end mt-6">
                                <p
                                    style="font-weight: bold;font-size: 24px;text-align: center;margin-right: 88px">
                                  อนุมัติ</p>
                              </v-list-item>
                              <v-list-item class="d-lg-flex d-none justify-end mt-10">
                                <img src="../assets/Image/license_or_thred.png" height="50"
                                     style="position: absolute;top: -36px;right: 83px">
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                                <img src="../assets/Image/license_or_thred.png" height="50"
                                     style="position: absolute;top: -36px;right: -16px">
                              </v-list-item>
                              <v-list-item class="d-lg-flex d-none justify-end">
                                <p style="font-size: 24px;text-align: center;margin-right: 124px">(ผศ.นพ.เทอดพงศ์
                                  ทองศรีราช)</p>
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end">
                                <p style="font-size: 24px;text-align: center;margin-right: 21px">(ผศ.นพ.เทอดพงศ์
                                  ทองศรีราช)</p>
                              </v-list-item>

                              <v-list-item class="d-lg-flex d-none justify-end">
                                <p style="font-size: 24px;text-align: center;margin-right: 160px">
                                  {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                  {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                  {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end">
                                <p style="font-size: 24px;text-align: center;margin-right: 64px">
                                  {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                  {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                  {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                              </v-list-item>
                            </list>
                          </v-col>
                        </v-row>
                      </v-container>
                      <!--                    <v-list>-->
                      <!--                      <v-list-item v-html="FormExpensesPrintData"></v-list-item>-->
                      <!--                    </v-list>-->
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined color="primary" @click="printFormExpanse">พิมพ์</v-btn>
              <v-btn outlined color="red" @click="dialogApproveForm = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogCompetency"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              Competency,Core Value,Strategic Objective
            </v-card-title>
            <v-card-text>
              <template v-if="CompetencyToShow.length > 0">
                <v-treeview :activatable="true" :items="CompetencyToShow">
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file" color="blue lighten-2">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                  <template v-slot:label="{ item, active }">
                    <div v-if="isMobile" style="cursor: pointer">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="font-size: 12px;color: #364eff;font-weight: bold"
                            v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                    <div v-else style="cursor: pointer">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                  </template>
                </v-treeview>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                  Competency,Core Value,Strategic Objective</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogCompetency = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogFile"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="FileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in FileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogFile = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            max-width="1200"
            persistent
            v-model="dialogJoinTravel">
          <v-card>
            <v-card-title>
              <h2 class="pb-4" style="font-weight: bold">ข้อมูลรายชื่อผู้เข้าร่วมเดินทาง</h2>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-6">
              <v-list>
                <v-list-item>
                  <v-data-table
                      class="mt-6"
                      :items="JoinTravel"
                      :headers="JoinTravelHeader"
                      style="width: 100%"
                  >
                    <template v-slot:header.customTravelDetail>
                      <h3 class="font-weight-bold">ผู้เดินทาง</h3>
                    </template>
                    <template v-slot:header.position>
                      <h3 class="font-weight-bold">ตำแหน่งระดับ(วันบรรจุ)</h3>
                    </template>
                    <template v-slot:header.Allowance>
                      <h3 class="font-weight-bold">ค่าเบี้ยเลี้ยง</h3>
                    </template>
                    <template v-slot:header.AccommodationCost>
                      <h3 class="font-weight-bold">ค่าที่พัก</h3>
                    </template>
                    <template v-slot:header.ShippingCosts>
                      <h3 class="font-weight-bold">ค่าพาหนะ</h3>
                    </template>
                    <template v-slot:header.RegistrationFee>
                      <h3 class="font-weight-bold">ค่าลงทะเบียน</h3>
                    </template>
                    <template v-slot:header.AllTravelExpenses>
                      <h3 class="font-weight-bold">รวมค่าเดินทาง</h3>
                    </template>
                    <template v-slot:header.RemainingBudget>
                      <h3 class="font-weight-bold">งบวิชาการคงเหลือ</h3>
                    </template>
                    <template v-slot:item="{item}">
                      <tr>
                        <td>
                          <div v-html="item.customTravelDetail"></div>
                        </td>
                        <td>{{ item.Allowance | currency }}</td>
                        <td>{{ item.AccommodationCost | currency }}</td>
                        <td>{{ item.ShippingCosts | currency }}</td>
                        <td>{{ item.RegistrationFee | currency }}</td>
                        <td>{{ item.AllTravelExpenses | currency }}</td>
                        <td>{{ item.RemainingBudget | currency }}</td>
                      </tr>
                      <!--                  <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text @click="editJoinTravel(item)">แก้ไข</v-btn>
                                        <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(item)">ลบ</v-btn>-->
                    </template>
                    <template v-slot:footer>
                      <v-divider></v-divider>
                      <v-row class="mt-4">
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าเบี้ยเลี้ยง:
                            <span style="color: black">{{ SumAllowance | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าที่พัก:
                            <span style="color: black">{{ SumAccommodationCost | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าพาหนะ:
                            <span style="color: black">{{ SumShippingCosts | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าลงทะเบียน:
                            <span style="color: black">{{ SumRegistrationFee | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าเดินทาง:
                            <span style="color: black">{{ SumAllTravelExpenses | currency }}</span>
                          </p>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="dialogJoinTravel = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import queryString from "query-string";
import Const from "@/const/Const";
import ALlFunc from "@/FuncGlobal/ALlFunc";

export default {
  name: "Project",
  data() {
    return {
      sortStatus: '1',
      selStatus: '1',
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      dialogCompetency: false,
      dialogFile: false,
      SumAllowance: 0,
      SumAccommodationCost: 0,
      SumShippingCosts: 0,
      SumRegistrationFee: 0,
      SumAllTravelExpenses: 0,
      JoinTravel: [],
      JoinTravelHeader: [
        {text: 'ผู้เดินทาง', value: 'customTravelDetail'},
        {text: 'ค่าเบี้ยเลี้ยง', value: 'Allowance'},
        {text: 'ค่าที่พัก', value: 'AccommodationCost'},
        {text: 'ค่าพาหนะ', value: 'ShippingCosts'},
        {text: 'ค่าลงทะเบียน', value: 'RegistrationFee'},
        {text: 'รวมค่าเดินทาง', value: 'AllTravelExpenses'},
        {text: 'งบวิชาการคงเหลือ', value: 'RemainingBudget'},
      ],
      dialogJoinTravel: false,
      Process: '1',
      typeIsPlan: '0',
      form1: true,
      form2: false,
      countAll: 0,
      countAll2: 0,
      countDep: 0,
      countFaculty: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count9: 0,
      positionToName: null,
      peridToName: null,
      maintain: false,
      dialogFormConside: false,
      dialogFormConsideEdit: false,
      dialogApproveForm: false,
      messageFormApprove: '',
      positionFormApprove: '',
      full_NameFormApprove: '',
      Project: null,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      dialogRound: false,
      tabs: null,
      RoundDataDump: [],
      groupDetail: null,
      groupQuataDump: [],
      dialogGroupDetail: false,
      roundHeader: [
        {text: 'รุ่น', value: 'round'},
        {text: 'ชื่อรุ่น', value: 'round_name'},
        {text: 'จำนวนผู้เข้าร่วม', value: 'count_person'},
        {text: '', value: 'action'},
      ],
      roundNeed: false,
      RoundData: [],
      round: '',
      round_name: '',
      dateRegS: '',
      dateRegE: '',
      time_start: '',
      time_end: '',
      typeStatus: 'A',
      IsPlan: '',
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: '',
      Project_plan: [],
      TypeCreateProject: '0',
      FiscalYearData: [],
      projectDataToTable: [],
      allProjectDataTemplate: [],
      allProjectDataTemplate2: [],
      allProjectDataToTable: [],
      allProjectDataToTableDump: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      WorkGroupData: [],
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      Expense: 0,
      DepSelect: '35000',
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataFormDB: '',
      editorData: '',
      editorData2: '',
      dialogLoading: false,
      dateApprove: '',
      Treasury: false,
      HR: false,
      CompetencyToShow: [],
      ReqMoney: '',
      Rm: '',
      selection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      CompetencyDataDump: [],
      RecordData: [],
      CheckAdmin: false,
      projectData2: [],
      JoinPerson: [],
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type'}
      ],
      studentData: [],
      Approve_m: null,
      Approve: [
        {
          id: '2',
          detail: 'อนุมัติ'
        },
        {
          id: '3',
          detail: 'ไม่อนุมัติ'
        },
        {
          id: '4',
          detail: 'แก้ไข'
        }
      ],
      FileProject: [],
      File_Consider: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 9,
      vertical: true,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      remarksApprove: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: 0,
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร', value: 'Lecturer'},
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: true,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในประเทศ'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      Approve_Status: [
        {
          id: '1',
          detail: 'รอพิจารณา',
          disable: true
        },
        {
          id: '4',
          detail: 'แก้ไข',
          disable: false
        },
        {
          id: '3',
          detail: 'ไม่อนุมัติ',
          disable: false
        },
        {
          id: '10',
          detail: 'เสนอพิจารณาอนุมัติ',
          disable: true
        },
        {
          id: '11',
          detail: 'อนุมัติ (ขั้นต้น)',
          disable: true
        },
        {
          id: '2',
          detail: 'อนุมัติ',
          disable: false
        },
      ],
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      // courseHeaders: [
      //   {
      //     text: 'รหัสหลักสูตร', class: 'HeaderTable',
      //     align: 'start',
      //     value: 'Project_code',
      //   },
      //   {text: 'หลักสูตร', value: 'Project_name'},
      //   {text: 'อนุมัติ', value: 'Approve'},
      //   {text: 'สถานะโครงการ', value: 'Project_Status'},
      //   // {text: 'HR พิจารณา', value: 'Approve_HR'},
      //   // {text: 'งานคลัง พิจารณา', value: 'Approve_Treasury'},
      //   {text: '', value: 'Project_Details'}
      // ],
      courseHeaders: [
        // {
        //   text: 'รหัสหลักสูตร', class: 'HeaderTable',
        //   align: 'start',
        //   value: 'Project_code',
        // },
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: '', value: 'Project_Details'}
      ],
      travelHeaders: [
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'IsPlanStatus'},
        // {text: 'Item_Code', value: 'Item_Code'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: 'จำนวนเงินอนุมัติ', value: 'BudgetArrove'},
        {text: 'จำนวนเงินเบิกจ่าย', value: 'MoneyDisburse'},
        {text: '', value: 'Project_Details'}
      ],
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
      ],
      budgetData: [],
    }
  },
  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    ...mapGetters({
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      GroupExamData: 'Project/getGroupExamProject',
      QuotaDepartData: 'Project/getQuotaDepart',
      JoinProjectData: 'Project/getJoinProject',
      GroupQuotaData: 'Project/getGroupQuota',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      ProjectRound: 'Project/getProjectRound',
      ApproveForm: 'Project/getApproveForm',
      ProjectRecord: 'Project/getProjectRecord',
      TravelForm: 'Project/getTravelForm',
      JoinTravelRes: 'Project/getJoinTravel',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      MeData: 'Staff/getMeData',
      AdminData: 'Staff/getAdminData',
      ApproveMaster: 'Staff/getApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermissionUser',

      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      TypeProject: 'Project/getTypeProject',
      StatusProject: 'Project/getStatusProject',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getProjectRoundData: 'Project/getProjectRoundData',
      getGroupExamProjectByCordi: 'Project/getGroupExamProjectByCordi',
      getQuotaDepartRegisterByCordi: 'Project/getQuotaDepartRegisterByCordi',
      getJoinProjectByCordi: 'Project/getJoinProjectByCordi',
      initApproveFormData: 'Project/initApproveFormData',
      initProjectRecordData: 'Project/initProjectRecordData',
      changeTypeProject: 'Project/changeTypeProject',
      initFileReportTravel: 'Project/initFileReportTravel',
      initJoinTravel: 'Project/initJoinTravel',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initMeData: 'Staff/initMeData',
      initAdminData: 'Staff/initAdminData',
      initApproveMaster: 'Staff/initApproveMaster',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',

      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    init: function () {
      this.dialogLoading = true
      this.CompetencyData = []
      this.projectData2 = []
      this.allProjectDataToTable = []
      this.allProjectDataToTableDump = []
      this.allProjectDataTemplate = []
      this.allProjectDataTemplate2 = []
      this.FiscalYearData = []
      this.BudgetArrove = 0
      var projectForApp = []

      for (var i = (new Date().getFullYear() - 1); i <= (new Date().getFullYear() + 1); i++) {
        this.FiscalYearData.push({
          year: i,
          yearth: i + 543
        })
      }

      // var query = ''
      this.initDepartData().then(resDep => {
        if (resDep) {
          this.initStaffData().then(res => {
            if (res) {
              this.initProjectDataForApprove({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  if (this.projectForApprove.length > 0) {
                    projectForApp = this.projectForApprove
                    if (projectForApp.length > 0) {
                      projectForApp.map(Project => {
                        Project.Project_name = Project.Project_name.replace(/&quot;/g, '"')
                        // console.log(parseInt(Project.IsPlanStatus) > 0 && Project.Approve == '0')
                        if (parseInt(Project.IsPlanStatus) > 0) {
                          var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                          if (DepBy.length > 0) {
                            this.allProjectDataToTable.push({
                              ...Project,
                              full_Name:
                                  ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                  '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                              Owner: true
                            })
                          } else if (DepBy.length == 0) {
                            this.allProjectDataToTable.push({
                              ...Project,
                              full_Name: ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                  '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                              Owner: true
                            })
                          } else {
                            this.allProjectDataToTable.push({
                              ...Project,
                              full_Name: ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                                  '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                              Owner: true
                            })
                          }
                        }
                      })
                      this.GetDepApprove()
                    } else {
                      this.dialogLoading = false
                    }
                  } else {
                    this.dialogLoading = false
                  }
                } else {
                  this.GetDepApprove()
                }
              }).catch(resCatch => {
                if (resCatch) {
                  this.dialogLoading = false
                }
              })
            }
          })
        }
      })

      this.initComitteeType()

      this.initCountryData()

      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      if (this.committee_Posi.length == 0) {
        this.initComitteeType()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      if (this.expense_Data.length == 0) {
        this.initExpenseData({
          cost_type: this.TypeProject
        })
      }

      this.initCompetencyData().then(res => {
        if (res) {
          this.Competency.map(compe_i => {
            if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes,
                  DelvLevel: '0',
                  checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                  children: []
                })
              } else {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                  DelvLevel: '0',
                  checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                  children: []
                })
              }
            }
          })
          this.CompetencyData.map((data_i, idx) => {
            if (data_i.children.length == 0) {
              this.Competency.map(compe_i => {
                if (data_i.DelvNo == compe_i.DelvCover) {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '1',
                      checkCordi: false,
                      children: []
                    })
                  } else {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '1',
                      checkCordi: false,
                      children: []
                    })
                  }
                }
              })
            }
          })
          // lv2
          this.CompetencyData.map(data_i => {
            if (data_i.children.length > 0) {
              data_i.children.map((child1_i, idx) => {
                if (child1_i.children.length == 0) {
                  this.Competency.map(compe_i => {
                    if (child1_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '2',
                          checkCordi: false,
                          children: []
                        })
                      } else {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '2',
                          checkCordi: false,
                          children: []
                        })
                      }

                    }
                  })
                }
              })
            }
          })

          // item to autocomplete
          this.CompetencyData.map(itemRoot => {
            this.itemsSel.push({
              ...itemRoot
            })
            if (itemRoot.children.length > 0) {
              itemRoot.children.map(itemChild1 => {
                this.itemsSel.push({
                  ...itemChild1
                })
                if (itemChild1.children.length > 0) {
                  itemChild1.children.map(itemChild2 => {
                    this.itemsSel.push({
                      ...itemChild2
                    })
                  })
                }
              })
            }
          })

          this.CompetencyDataDump = JSON.parse(JSON.stringify(this.CompetencyData))
        }
      })

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }

      if (this.levelData.length == 0) {
        this.initlevelData()
      }

      if (this.CardData.length == 0) {
        this.initCardData()
      }

      if (this.AdminData.length == 0) {
        this.initAdminData()
      }

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })
    },
    get_full_Name() {
      if (this.peridToName != null || this.peridToName != '') {
        this.staffData.filter(item => item.perid == this.peridToName).length > 0 ? this.full_NameFormApprove = this.staffData.filter(item => item.perid == this.peridToName)[0].full_Name : this.full_NameFormApprove = ''
      }
    },
    get_Position() {
      if (this.positionToName != null || this.positionToName != '') {
        this.positions.filter(item => item.PosCode == this.positionToName).length > 0 ? this.positionFormApprove = this.positions.filter(item => item.PosCode == this.positionToName)[0].PosName : this.positionFormApprove = ''
      }
    },
    printFormExpanse() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({
        name: 'PrintData',
        query: {data: document.getElementById('FormExpensesPrintData').innerHTML}
      });
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    FormExpenses(ProjectCode) {
      this.FormExpensesPrintData = ''
      this.dialogLoading = true
      this.initApproveFormData({
        Project_code: ProjectCode
      }).then(async res => {
        if (res) {
          if (this.ApproveForm.length > 0) {
            this.ApproveForm[0].message = this.ApproveForm[0].message.replaceAll('&quot;', '"')
            await this.initProjectRecordData({
              Project_code: ProjectCode
            })
            this.dialogApproveForm = true
            this.dialogLoading = false
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลแบบฟอร์ฺมการเบิกจ่ายเงิน !!'
            })
          }
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูลแบบฟอร์ฺมการเบิกจ่ายเงิน !!'
          })
        }
      })
    },
    GetRoundDetail(item) {
      this.RoundDataDump = null
      this.RoundDataDump = item
      this.ProjectQuotaDepCount = 0
      var RoundDump = this.RoundData.filter(Round_i => Round_i.id == item.id)
      if (RoundDump.length > 0) {
        this.round = RoundDump[0].round
        this.round_name = RoundDump[0].round_name
        this.dateRegS = RoundDump[0].dateRegS
        this.dateRegE = RoundDump[0].dateRegE
        this.time_start = RoundDump[0].time_start
        this.time_end = RoundDump[0].time_end
        this.DataCondi = RoundDump[0].WorkAgeData
        if (this.DataCondi.length > 0) {
          this.DataCondi.map(dataI => {
            dataI.workAgeStart = dataI.WSYear
            dataI.workAgeEnd = dataI.WEYear
          })
        }
        this.ChooseTypRegis = RoundDump[0].ChooseTypRegis
        this.ChooseTypRegis2 = RoundDump[0].ChooseTypRegis2
        this.dateRegStart = RoundDump[0].dateRegStart
        this.dateRegEnd = RoundDump[0].dateRegEnd
        this.ChkJoinPerson = RoundDump[0].ChkJoinPerson
        if (RoundDump[0].ProjectQuotaCount == '0') {
          this.ProjectQuotaCount = ''
        } else {
          this.ProjectQuotaCount = RoundDump[0].ProjectQuotaCount
        }

        this.DepQuotaData = RoundDump[0].DepQuotaData
        if (this.DepQuotaData.length > 0) {
          this.DepQuotaData.map(Group_I => {
            this.ProjectQuotaDepCount += parseInt(Group_I.count)
          })
        }
        this.JoinPerson = RoundDump[0].JoinPersonData

      }
      this.dialogRound = true
    },
    ChooseTypeStatus() {
      if (this.allProjectDataTemplate.length == 0) {
        this.allProjectDataTemplate = this.allProjectDataToTable.length > 0 ? [...this.allProjectDataToTable] : []
        this.allProjectDataTemplate2 = this.allProjectDataToTable.length > 0 ? [...this.allProjectDataToTable] : []
      }
      if (this.allProjectDataToTableDump.length == 0) {
        if (this.Process == '1') {
          this.allProjectDataToTableDump = this.allProjectDataTemplate.filter(item => item.Approve == '0' && item.Project_type == this.Process)
        } else {
          // แก้ไข ตอน 20 มิ.ย. 67
          // this.allProjectDataToTableDump = this.allProjectDataTemplate.filter(item => item.Project_type == '2' && ((item.IsProcess != '3' && item.IsExpense != '0') || (item.IsProcess == '3' && item.IsExpense == '1')))
          this.allProjectDataToTableDump = this.allProjectDataTemplate.filter(item => item.Project_type == '2' && ((item.IsProcess != '3') || (item.IsProcess == '3' && item.IsExpense == '1')))
          console.log(this.allProjectDataToTableDump)
        }
      }
      this.allProjectDataToTable = []
      if (this.Process == '1') {
        this.allProjectDataToTable = this.allProjectDataTemplate.filter(item => item.Approve == '0' && item.Project_type == this.Process)
      } else {
        this.allProjectDataToTable = this.allProjectDataTemplate.filter(item => item.Project_type == this.Process && ((item.IsProcess != '3') || (item.IsProcess == '3' && item.IsExpense == '1')))
      }
      // this.cal_count_type()
    },
    cal_count_type() {
      this.countAll = this.allProjectDataToTableDump.length
      this.countDep = this.allProjectDataToTableDump.filter(item => item.Approve == '0').length

      if (this.typeStatus == '3') {

        this.countAll2 = this.allProjectDataToTableDump.length
        this.count1 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '1').length
        this.count2 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '2').length
        this.count3 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '3').length
        this.count4 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '4').length

      } else if (this.typeStatus == '1') {

        this.countAll2 = this.allProjectDataToTableDump.filter(item => item.Approve == '1').length
        this.count1 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '1').length
        this.count2 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '2').length
        this.count3 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '3').length
        this.count4 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '4').length

      } else {
        this.countAll2 = this.allProjectDataToTableDump.filter(item => item.Approve == '0').length
        this.count1 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '1').length
        this.count2 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '2').length
        this.count3 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '3').length
        this.count4 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '4').length
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({
        name: 'PrintData',
        query: {data: (this.form1 ? this.editorData : this.editorData2)}
      });
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != '' && this.dateEForLecturer != '' && this.timeSForLecturer != '' && this.timeEForLecturer != '') {
        this.Lecturer.push({
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer
        })
        this.SubjectForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    ChangeForm(idForm) {
      if (idForm == '1') {
        this.form1 = true
        this.form2 = false
      } else {
        this.form1 = false
        this.form2 = true
      }
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    GetDepApprove() {
      var projectForApp = []
      this.getPermissionDep({
        perid: this.MeData[0].perid
      }).then(res => {
        if (res) {
          if (this.Permission_Dep.length > 0) {
            projectForApp = this.projectForApprove
            if (projectForApp.length > 0) {
              projectForApp.map(Project => {
                var DepData = this.Permission_Dep.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                if (DepData.length > 0) {
                  if (parseInt(Project.IsPlanStatus) > 0) {
                    if (DepBy.length > 0) {
                      if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                        this.allProjectDataToTable.push({
                          ...Project,
                          full_Name: '<div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                              ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                              ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                          Owner: true
                        })
                      }
                    } else if (DepBy.length == 0) {
                      if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                        this.allProjectDataToTable.push({
                          ...Project,
                          full_Name: '<div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                              ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                          Owner: true
                        })
                      }
                    } else {
                      if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                        this.allProjectDataToTable.push({
                          ...Project,
                          full_Name: '<div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                              '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                          Owner: true
                        })
                      }
                    }
                  }
                }
              })
              this.ChooseProcess()
            }
          } else {
            this.initPermissionDepUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                if (this.Permission_Dep_User.length > 0) {
                  projectForApp = this.projectForApprove
                  if (projectForApp.length > 0) {
                    this.projectForApprove.map(Project => {
                      var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                      var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                      if (DepData.length > 0) {
                        if (parseInt(Project.IsPlanStatus) > 0) {
                          if (DepBy.length > 0) {
                            if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                              this.allProjectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                                Owner: true
                              })
                            }
                          } else if (DepBy.length == 0) {
                            if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                              this.allProjectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                                Owner: true
                              })
                            }
                          } else {
                            if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                              this.allProjectDataToTable.push({
                                ...Project,
                                full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                                Owner: true
                              })
                            }
                          }
                        }
                      }
                    })
                    this.ChooseTypeStatus()
                  }
                }
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(reason => {
        if (reason) {
          this.initPermissionDepUserData({
            perid: this.MeData[0].perid
          }).then(res => {
            if (res) {
              projectForApp = this.projectForApprove
              if (projectForApp.length > 0) {
                if (this.Permission_Dep_User.length > 0) {
                  this.projectForApprove.map(Project => {
                    var DepData = this.Permission_Dep_User.filter(Dep => Project.Dep_Code == Dep.dep_id || Project.dep_id == Dep.dep_id)
                    var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                    if (DepData.length > 0) {
                      if (parseInt(Project.IsPlanStatus) > 0) {
                        if (DepBy.length > 0) {
                          if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                            this.allProjectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                              Owner: true
                            })
                          }
                        } else if (DepBy.length == 0) {
                          if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                            this.allProjectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>',
                              Owner: true
                            })
                          }
                        } else {
                          if (this.allProjectDataToTable.filter(itemP => itemP.Project_code == Project.Project_code).length == 0) {
                            this.allProjectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                              Owner: true
                            })
                          }
                        }
                      }
                    }
                  })
                }
                this.ChooseTypeStatus()
              }
            }
          }).catch(resCatch => {
            if (resCatch) {
              this.ChooseTypeStatus()
            }
          })
        }
        this.dialogLoading = false
      })
    },
    BackMenu() {
      this.Project = null
      this.Details_Cordi = false
      this.files = []
      this.File_Consider = []
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    DeleteFile(idx) {
      this.File_Consider.splice(idx, 1)
    },
    ShowCompeDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/' + item.Project_code
      axios.get(urlConnection).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          // Error Competency
        }
      })
    },
    showTravelCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      this.dialogLoading = true
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/' + item.Project_code
      axios.get(urlConnection).then(res => {
        if (res.data) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          this.dialogCompetency = true
          this.dialogLoading = false
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
        }
      })
    },
    showFile() {
      this.dialogFile = true
    },
    showFileReport(proj) {
      this.dialogLoading = true
      this.initFileReportTravel({
        Project_code: proj.Project_code
      }).then(res => {
        if (res) {
          this.dialogLoading = false
          if (this.TravelForm.length > 0) {
            if (this.TravelForm[0].file_name != null) {
              window.open(ConstData.ConnectionHost + '/HrTrain2/upload/file/' + this.TravelForm[0].file_name, '_blank');
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบไฟล์เอกสารแบบฟอร์ม!'
              })
            }
          }
        }
      })
    },
    showJoinTravel() {
      this.dialogJoinTravel = false
      this.dialogJoinTravel = true
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    initApproveFormConsider() {
      this.initApproveFormData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          if (this.ApproveForm.length > 0) {
            this.ApproveForm[0].message = this.ApproveForm[0].message.replaceAll('&quot;', '"')
            this.messageFormApprove = this.ApproveForm[0].message
            this.full_NameFormApprove = this.ApproveForm[0].name
            this.positionFormApprove = this.ApproveForm[0].position
          } else {
            this.messageFormApprove = 'โครงการ ' + this.Project_name + '\nCompetency/สมรรถนะ/SO\n'
            if (this.selection.length > 0) {
              this.CompetencyData.map(root => {
                for (var i = 0; i <= this.selection.length - 1; i++) {
                  if (root.children.length > 0) {
                    root.children.map(child1 => {
                      if (child1.children.length > 0) {
                        child1.children.map(child2 => {
                          if (child2.id == this.selection[i]) {
                            this.messageFormApprove += root.DelvDes + ' -> ' + child1.DelvDes + ' -> ' + child2.DelvDes + '\n'
                          }
                        })
                      }
                      if (child1.id == this.selection[i]) {
                        this.messageFormApprove += root.DelvDes + ' -> ' + child1.DelvDes + '\n'
                      }
                    })
                  }
                  if (root.id == this.selection[i]) {
                    this.messageFormApprove += root.DelvDes + '\n'
                  }
                }
              })
            }
            this.full_NameFormApprove = ''
            this.positionFormApprove = ''
          }
        }
      }).catch(res => {
        if (res) {
          this.messageFormApprove = 'โครงการ ' + this.Project_name + '\nCompetency/สมรรถนะ/SO\n'
          if (this.selection.length > 0) {
            this.CompetencyData.map(root => {
              for (var i = 0; i <= this.selection.length - 1; i++) {
                if (root.children.length > 0) {
                  root.children.map(child1 => {
                    if (child1.children.length > 0) {
                      child1.children.map(child2 => {
                        if (child2.id == this.selection[i]) {
                          this.messageFormApprove += root.DelvDes + ' -> ' + child1.DelvDes + ' -> ' + child2.DelvDes + '\n'
                        }
                      })
                    }
                    if (child1.id == this.selection[i]) {
                      this.messageFormApprove += root.DelvDes + ' -> ' + child1.DelvDes + '\n'
                    }
                  })
                }
                if (root.id == this.selection[i]) {
                  this.messageFormApprove += root.DelvDes + '\n'
                }
              }
            })
          }
          this.full_NameFormApprove = ''
          this.positionFormApprove = ''
        }
      })
    },
    ShowDetail(item) {
      this.dialogLoading = true
      this.e1 = '1'
      this.tabMenu = '1'
      this.Expense = 0
      this.episode = null

      this.files = []
      this.Coordinator = []
      this.courseCondi = []
      this.competency_DataForSubmit = []
      this.expense_DataForSubmit = []
      this.expense_p_DataForSubmit = []
      this.FileProject = []
      this.DataCondi = []
      this.JoinPerson = []
      this.selection = []
      this.logSelection = []
      this.budgetData = []
      this.Lecturer = []
      this.TemplateProject = []
      this.DepQuotaData = []
      this.RecordData = []
      this.RecordDataDump = []
      this.TempRecordData = []
      this.FileProjectOld = []
      this.FileProject = []
      this.Project = null

      this.editorData = ''
      this.dateApprove = ALlFunc.getDateNow()
      this.Approve_m = null
      this.remarksApprove = ''
      this.JoinTravel = []

      this.Details_Cordi = true
      this.Project = item
      this.Project_code = item.Project_code
      this.Project_name = item.Project_name
      this.Course_code = item.Course_code
      this.course_group = item.Course_group
      this.Period_code = item.Period_code
      this.Project_type = item.Project_type
      this.Objective = item.Objective
      this.TargetGroup = item.TargetGroup
      this.IsProcess = item.IsProcess
      this.Project_category = item.Project_category
      this.Remarks = item.Remarks
      this.CalCredit = '' + item.CalCredit
      this.CalHourse = '' + item.CalHourse
      this.PLACE = item.PLACE
      this.Province_id = item.Province_id
      this.Country_id = item.Country_id
      this.BudgetRequest = item.BudgetRequest
      this.Location = item.Location
      this.WorkBy = item.WorkBy
      this.WorkByName = item.WorkByName
      this.WorkByPhone = item.WorkByPhone
      this.episode = item.DatePeriod
      this.DateStart = item.DateStart
      this.DateEnd = item.DateEnd
      this.DepSelect = item.Dep_Code
      this.Project_group = item.Project_group
      this.FiscalYear = parseInt(item.FiscalYear)
      this.IsPlan = item.IsPlan
      this.IsPlanStatus = item.IsPlanStatus
      this.itemCode = item.Item_Code
      this.Status = item.Status
      this.Approve = item.Approve

      this.ChooseTypeDep = item.Approve
      this.ChooseTypRegis = item.Status_Reg
      this.ChooseTypRegis2 = item.Status_Type_Reg
      this.dateRegStart = item.DateS_Reg
      this.dateRegEnd = item.DateE_Reg
      this.ProjectQuotaCount = item.Count_Reg
      var checkMatch = false

      this.SumAllowance = 0
      this.SumAccommodationCost = 0
      this.SumShippingCosts = 0
      this.SumRegistrationFee = 0
      this.SumAllTravelExpenses = 0

      if (item.Status_Count_Reg == '0') {
        this.ChkJoinPerson = false
      } else {
        this.ChkJoinPerson = true
      }

      // this.showCompetency(item)


      this.SelProjectGroup()
      this.getCourseType()
      this.getCompetency()
      this.initJoinTravel({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.JoinTravelRes.map((item) => {
            checkMatch = false
            this.staffData.map(staff_i => {
              if (staff_i.perid == item.uid) {
                checkMatch = true
                this.JoinTravel.push({
                  ...item,
                  ...staff_i,
                  idx: this.JoinTravel.length + 1,
                  full_Name: item.full_name,
                  customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                      '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                  AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                  Lecturer: this.Lecturer.length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid).length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid) : null : null,
                  files: [],
                  idCard: item.id_card,
                  status_reg: item.join_status
                })
              }
            })
            if (!checkMatch) {
              this.JoinTravel.push({
                ...item,
                idx: this.JoinTravel.length + 1,
                full_Name: item.full_name,
                customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                    '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                Lecturer: this.Lecturer.length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid).length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid) : null : null,
                files: [],
                idCard: item.id_card,
                status_reg: item.join_status
              })
            }
          })
          if (this.JoinTravel.length > 0) {
            this.JoinTravel.map((item, idx) => {
              item.idx = (this.JoinTravel.length - (idx + 1)) + 1
              this.SumAllowance += parseFloat(item.Allowance)
              this.SumAccommodationCost += parseFloat(item.AccommodationCost)
              this.SumShippingCosts += parseFloat(item.ShippingCosts)
              this.SumRegistrationFee += parseFloat(item.RegistrationFee)
              this.SumAllTravelExpenses += parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee)
            })
          }
        }
      })

      this.initProjectExpenseData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectExpense.map(ProjectEx => {
            this.expense_Data.map(expenseData => {
              if (ProjectEx.Expense_id == expenseData.Expense_id) {
                this.budgetData.push({
                  Expense_id: expenseData.Expense_id,
                  Expense_des: expenseData.Expense_des,
                  ReqMoney: ProjectEx.ReqMoney,
                  Rm: ProjectEx.Rm
                })
                this.Expense += parseFloat(ProjectEx.ReqMoney)
              }
            })

          })
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.Project_code).then(res => {
        if (res.data) {
          var type = ''
          if (res.data.length > 0) {
            this.projectNeed = true
            res.data.map((item_qua) => {
              type = ''
              if (item_qua.dep_type == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: item_qua.dep_type,
                type: type,
                type_id: item_qua.dep_type,
                dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                count: item_qua.count
              })
            })
          } else {
            this.projectNeed = true
            type = ''
            if (res.data.dep_type == '0') {
              type = 'หน่วยงาน/ภาควิชา'
            } else {
              type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
            }
            this.DepQuotaData.push({
              quotaType: res.data.dep_type,
              type: type,
              type_id: res.data.dep_type,
              dep_name: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_name,
              dep_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_id,
              dep_group_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_group_id,
              count: res.data.count
            })
          }

          if (this.DepQuotaData.length > 0) {
            this.DepQuotaData.map(item_dep_q => {
              this.ProjectQuotaDepCount += parseInt(item_dep_q.count)
            })
          }
        } else {
          this.projectNeed = false
          this.DepQuotaData = []
        }
      })


      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.WorkGroupData = res.data
          } else {
            this.projectNeed = true
            this.WorkGroupData.push(res.data)
          }

          if (this.WorkGroupData.length > 0) {
            this.WorkGroupData.map(item_w => {
              this.getTrainFiles(item_w.Ref_id).then(res => {
                item_w.files = res
              })
            })
          }
        } else {
          this.projectNeed = false
          this.WorkGroupData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.TemplateProject = res.data
          } else {
            this.projectNeed = true
            this.TemplateProject.push(res.data)
          }
          if (this.TemplateProject.length > 0) {
            this.editorDataFormDB = this.TemplateProject[0].Template
            this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
          }
        } else {
          this.projectNeed = false
          this.TemplateProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record_view/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.TempRecordData = res.data
          } else {
            this.TempRecordData.push(res.data)
          }
        } else {
          this.TempRecordData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }
              this.RecordDataDump = this.RecordData
            } else {
              this.dialogLoading = false
              this.RecordDataDump = this.RecordData
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
          this.RecordDataDump = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.DataCondi = res.data
          } else {
            this.DataCondi.push(res.data)
          }
          if (this.DataCondi.length > 0) {
            this.DataCondi.map(item => {
              item.workAgeStart = item.WSYear
              item.workAgeEnd = item.WEYear
            })
          }
        } else {
          this.DataCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.courseCondi = res.data
          } else {
            this.courseCondi.push(res.data)
          }
        } else {
          this.courseCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.Coordinator = res.data
          } else {
            this.Coordinator.push(res.data)
          }

          this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
          this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
          if (this.Committee_ToShow.length > 0) {
            this.Committee_ToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
          if (this.LecturerToShow.length > 0) {
            this.LecturerToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
        } else {
          this.projectNeed = false
          this.Coordinator = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Type/0/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((f_item) => {
              switch (f_item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProject.push({
                    ...f_item,
                    name: f_item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + f_item.File_path,
                    path: f_item.File_path,
                    type: 'image',
                    type_Img: f_item.File_type
                  })
                  break
                case 'application/pdf':
                  this.FileProject.push({
                    ...f_item,
                    name: f_item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + f_item.File_path,
                    path: f_item.File_path,
                    type: 'pdf',
                    type_Img: f_item.File_type
                  })
                  break
                default:
                  break
              }
            })
          } else {
            switch (res.data.File_type) {
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                this.FileProject.push({
                  ...res.data,
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'image',
                  type_Img: res.data.File_type
                })
                break
              case 'application/pdf':
                this.FileProject.push({
                  ...res.data,
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'pdf',
                  type_Img: res.data.File_type
                })
                break
              default:
                break
            }
          }
          this.FileProjectOld = [...this.FileProject]
        } else {
          this.FileProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code + '/active/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              this.JoinPerson.push({
                ...item,
                full_Name: item.name + ' ' + item.sname,
                idCard: item.id_card,
              })
            })
          } else {
            this.JoinPerson.push({
              ...res.data,
              full_Name: res.data.name + ' ' + res.data.sname,
              idCard: res.data.id_card,
            })
          }
        } else {
          this.JoinPerson = []
        }
      })
    },
    ExecQuotaDepartRegisterProject(Project_code, objItem) {
      var QuotaDepDump = []
      return new Promise(resolve => {
        this.getQuotaDepartRegisterByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resQuota => {
          if (resQuota) {
            if (this.QuotaDepartData.length > 0) {
              var type = ''
              this.QuotaDepartData.map((item_qua) => {
                type = ''
                if (item_qua.dep_type == '0') {
                  type = 'หน่วยงาน/ภาควิชา'
                } else {
                  type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                }
                QuotaDepDump.push({
                  quotaType: item_qua.dep_type,
                  type: type,
                  type_id: item_qua.dep_type,
                  dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                  count: item_qua.count
                })
              })
            }
            resolve(QuotaDepDump)
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    ExecJoinProject(Project_code, objItem) {
      var JoinPersonDump = []
      return new Promise(resolve => {
        this.getJoinProjectByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resJoin => {
          if (resJoin) {
            if (this.JoinProjectData.length > 0) {
              this.JoinProjectData.map((item) => {
                JoinPersonDump.push({
                  ...item,
                  full_Name: item.name + ' ' + item.sname,
                  idCard: item.id_card,
                  status_reg: item.join_status
                })
              })
            }
            resolve(JoinPersonDump)
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    ExecGroupExamProject(Project_code, objItem) {
      return new Promise(resolve => {
        this.getGroupExamProjectByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resGroup => {
          if (resGroup) {
            if (this.GroupExamData.length > 0) {
              resolve(this.GroupExamData)
            }
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    Project_proposal(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.proposal = []
          this.proposal = item
          this.dialogProposal = true
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    OpenLinkApprove(item) {
      window.open(
          Const.ConnectionHostHrTrain + '/ApproveTravelByDep/' + item.Project_code,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    DelProjectOwner(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบข้อมูลโครงการ " + item.Project_name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code + '/?limit=1', '', {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + res.data.Ref_id, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + res.data.Ref_id, '', headerAxios)
            }
          })

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + item.project_id, '', headerAxios)

          setTimeout(() => {
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'ลบข้อมูลโครงการ  ' + item.Project_name + '  สำเร็จ!!'
            }, 1500)
            this.init()
          })
        }
      })
    },
    DelProject(item) {
      this.initMeData().then(async res => {
        if (res) {
          this.CheckPermissFunc('1001').then(res => {
            if (res) {
              this.$swal.fire({
                title: 'ยืนยันการทำรายการ',
                text: "คุณต้องการลบข้อมูล " + item.Project_name + ' ใช่หรือไม่ ??',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
              }).then((result) => {
                if (result.value) {
                  axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                    queryName: 'cancelProject',
                    param: btoa(JSON.stringify({
                      Project_code: item.Project_code,
                      perid: this.MeData[0].perid,
                    }))
                  }).then(async res => {
                    if (res.data.status) {
                      setTimeout(() => {
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'ลบข้อมูลโครงการ  ' + item.Project_name + '  สำเร็จ!!'
                        }, 1500)
                        this.init()
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาดไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      }).catch(reason => {
        console.log('Reject = ' + reason)
      })
    },
    GetData(item, IsExp, FuncExp) {
      this.DataCondi = []
      this.courseCondi = []
      if (IsExp) {
        FuncExp(false)
      } else {
        FuncExp(true)

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {
            this.projectNeed = true
            if (res.data.length > 0) {
              this.DataCondi = res.data
            } else {
              this.DataCondi.push(res.data)
            }
          } else {
            this.DataCondi = []
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {
            this.projectNeed = true
            if (res.data.length > 0) {
              this.courseCondi = res.data
            } else {
              this.courseCondi.push(res.data)
            }
          } else {
            this.courseCondi = []
          }
        })
      }
    },
    ChangeStatus: function (item) {
      if (item.Course_status == '1') {
        const param = {
          Course_status: '9'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data) {
            this.init()
          }
        })
      } else {
        const param = {
          Course_status: '1'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data.status) {
            this.init()
          }
        })
      }
    },
    FileSelect: function () {
      // var count = 0
      this.dialogLoading = true
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.dialogLoading = false
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
              this.alert = true
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    case 'application/pdf':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    default:
                      break
                  }

                }
              })
            }
          } else {
            this.dialogLoading = false
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }
    },
    getCourseType() {
      if (this.Course_code == null) {
        this.course_group = ''
        // this.Project_code = ''
        this.Period_code = 0
        this.CalHourse = '0'
        this.CalCredit = '0'
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.Course_code) {
            this.course_group = item.Course_type_des
            this.Period_code = item.Period_code
            this.CalHourse = item.Course_hour
            this.CalCredit = item.General_credit
          }
        })
      }
    },
    getCompetency() {
      this.logSelection = []
      this.selection = []
      this.initProjectCompetencyData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
          this.logSelection = [...this.selection]
        }
        this.ChooseCompetency()
      })
    },
    ChooseCompetency() {
      this.CompetencyData = JSON.parse(JSON.stringify(this.CompetencyDataDump))
      if (this.Project_category == '1') {
        this.CompetencyData[0].checkCordi = true
        this.CompetencyData[2].checkCordi = true
      } else {
        this.CompetencyData[0].checkCordi = false
        this.CompetencyData[2].checkCordi = true
      }
      if (this.selection.length > 0) {
        for (var i = 0; i <= this.selection.length - 1; i++) {
          this.CompetencyData.map(root => {
            if (root.children.length > 0) {
              root.children.map(child1 => {
                if (child1.children.length > 0) {
                  child1.children.map(child2 => {
                    if (child2.id == this.selection[i]) {
                      if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                        root.checkCordi = false
                      }
                    }
                  })
                }
                if (child1.id == this.selection[i]) {
                  if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                    root.checkCordi = false
                  }
                }
              })
            }
            if (root.id == this.selection[i]) {
              if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                root.checkCordi = false
              } else {
                root.checkCordi = true
              }
            }
          })
        }
      }
      this.getCourseType()
    },
    AddCompetency() {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return new Promise(resolve => {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + this.Project_code).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + this.Project_code, {
              active: '0',
              update_by: this.MeData[0].perid
            }, headerAxiosDel).then(res => {
              if (res.data.status) {
                if (this.selection.length > 0) {
                  this.CompetencyData.map(root => {
                    for (var i = 0; i <= this.selection.length - 1; i++) {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == this.selection[i]) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: this.Project_code,
                                  DelvNo: child2.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (child1.id == this.selection[i]) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: this.Project_code,
                              DelvNo: child1.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (root.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: this.Project_code,
                          DelvNo: root.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    }
                  })
                  this.selection = []
                  resolve(true)
                } else {
                  resolve(true)
                }
              } else {
                resolve(false)
              }
            })
          } else {
            if (this.selection.length > 0) {
              for (var i = 0; i <= this.selection.length - 1; i++) {
                this.CompetencyData.map(root => {
                  if (root.children.length > 0) {
                    root.children.map(child1 => {
                      if (child1.children.length > 0) {
                        child1.children.map(child2 => {
                          if (child2.id == this.selection[i]) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: this.Project_code,
                              DelvNo: child2.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (child1.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: this.Project_code,
                          DelvNo: child1.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (root.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                      Project_code: this.Project_code,
                      DelvNo: root.DelvNo,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()'
                    }, headerAxiosPUT)
                  }
                })
              }
              this.selection = []
              resolve(true)
            } else {
              resolve(true)
            }
          }
        })
      })
    },
    showErrorConside() {
      this.$swal.fire({
        icon: 'error',
        title: 'โปรดกรอกข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
      })
    },
    EditFormConside() {
      if (this.messageFormApprove == '' || this.full_NameFormApprove == '' || this.positionFormApprove == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
        })
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            this.CheckPermissFunc('1001').then(res => {
              if (res) {
                var param = null

                const headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                const headerAxiosUpdate = {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }

                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_Form/active/1/Project_code/' + this.Project_code).then(resGetApproveF => {
                  if (resGetApproveF.data) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_Form/Project_code/' + this.Project_code, {
                      Project_code: this.Project_code,
                      message: this.messageFormApprove,
                      name: this.full_NameFormApprove,
                      position: this.positionFormApprove,
                      status: '0',
                      Update_By: this.MeData[0].perid,
                    }, headerAxiosUpdate).then(resUpApproveF => {
                      if (resUpApproveF.data.status) {
                        this.initApproveMasterByType({
                          type: '3'
                        }).then(res => {
                          if (res) {
                            if (this.ApproveMaster.length > 0) {
                              this.ApproveMaster.map(App_item => {
                                axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                  perid_admin: App_item.perid,
                                  perid: this.MeData[0].perid,
                                  headerName: 'แจ้งเตือนการพิจารณาโครงการ ' + this.Project.Project_name,
                                  header: 'โครงการ ' + this.Project.Project_name,
                                  body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">โครงการ ' + this.Project.Project_name + ' ได้ถูกเสร็จสิ้นโครงการแล้ว </p> ' +
                                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">หัวหน้างานพัฒนาทรัพยากรมนุษย์</span> โปรดพิจารณาโครงการในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาโครงการ </a> </p> ' +
                                      '<hr style="margin-top: 50px;">' +
                                      '<p style="font-size: 16px;color: #ff6d81">ระบบพัฒนาฝึกอบรม</p>' +
                                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
                                }), {
                                  headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                  }
                                })
                              })
                            }
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.dialogFormConsideEdit = false
                            this.initApproveFormConsider()
                          }
                        }).catch(res => {
                          if (res) {
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.dialogFormConsideEdit = false
                            this.initApproveFormConsider()
                          }
                        })
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ'
                        })
                      }
                    }).catch(res => {
                      if (res) {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ'
                        })
                      }
                    })
                  } else {
                    param = {
                      Project_code: this.Project_code,
                      message: this.messageFormApprove,
                      name: this.full_NameFormApprove,
                      position: this.positionFormApprove,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Approve_Form/', param, headerAxios).then(res => {
                      if (res.data.status) {
                        this.initApproveMasterByType({
                          type: '3'
                        }).then(res => {
                          if (res) {
                            if (this.ApproveMaster.length > 0) {
                              this.ApproveMaster.map(App_item => {
                                axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                  perid_admin: App_item.perid,
                                  perid: this.MeData[0].perid,
                                  headerName: 'แจ้งเตือนการพิจารณาโครงการ ' + this.Project.Project_name,
                                  header: 'โครงการ ' + this.Project.Project_name,
                                  body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">โครงการ ' + this.Project.Project_name + ' ได้ถูกเสร็จสิ้นโครงการแล้ว </p> ' +
                                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">หัวหน้างานพัฒนาทรัพยากรมนุษย์</span> โปรดพิจารณาโครงการในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาโครงการ </a> </p> ' +
                                      '<hr style="margin-top: 50px;">' +
                                      '<p style="font-size: 16px;color: #ff6d81">ระบบพัฒนาฝึกอบรม</p>' +
                                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
                                }), {
                                  headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                  }
                                })
                              })
                            }
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.dialogFormConsideEdit = false
                            this.initApproveFormConsider()
                          }
                        }).catch(res => {
                          if (res) {
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                            this.dialogFormConsideEdit = false
                            this.initApproveFormConsider()
                          }
                        })
                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ'
                        })
                      }
                    }).catch(res => {
                      if (res) {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ'
                        })
                      }
                    })
                  }
                })
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                })
              }
            })
          }
        })
      }
    },
    ChooseProcess() {
      if (this.Process == '1') {
        this.changeTypeProject({
          type: '1'
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp1
        })
      } else {
        this.changeTypeProject({
          type: '2'
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp2
        })
      }
      this.ChooseTypeStatus()
    },
    ConsideProject() {
      this.initMeData().then(async res => {
        if (res) {
          if (this.Approve_m == null || this.dateApprove == '') {
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดกรอกข้อมูล สำหรับพิจารณาโครงการให้ครบถ้วน'
            })
          } else {
            this.$swal.fire({
              title: 'ยืนยันการทำรายการ',
              text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'ตกลง',
              cancelButtonText: 'ยกเลิก'
            }).then((result) => {
              if (result.value) {
                this.CheckPermissFunc('1001').then(res => {
                  if (res) {
                    var param = null
                    const headerAxios = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }

                    param = {
                      Project_code: this.Project_code,
                      Type: '3',
                      Status: this.Approve_m,
                      Remark: this.remarksApprove,
                      Date_Approve: this.dateApprove,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, headerAxios).then(res => {
                      if (res.data) {
                        if (this.File_Consider.length > 0) {
                          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + this.Project_code + '/?sort=id_DESC&limit=1', param, headerAxios).then(res => {
                            if (res.data) {
                              const headerAxiosPUT = {
                                headers: {
                                  'Content-Type': 'application/json',
                                  'X-REST-METHOD': 'PUT'
                                }
                              }

                              var Count = 0

                              this.File_Consider.map((item) => {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                                  Project_code: this.Project.Project_code,
                                  File_name: item.name,
                                  File_path: item.path,
                                  File_type: item.type_Img,
                                  Type: '2',
                                  project_record_id: res.data.id
                                }, headerAxiosPUT).then(res => {
                                  if (res.data.status) {
                                    Count++
                                    if (Count == this.File_Consider.length) {
                                      this.File_Consider = []
                                      this.files = []

                                      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                                        queryName: 'updateStatusProject',
                                        param: btoa(JSON.stringify({
                                          IsPlanStatus: this.Approve_m,
                                          Project_code: this.Project_code,
                                          perid: this.MeData[0].perid,
                                        }))
                                      }).then(async res => {
                                        if (res.data.status) {
                                          await this.AddCompetency()
                                          this.SendMail({
                                            headerName: this.TypeProject == '1' ? 'แจ้งผลการพิจารณาโครงการ' : 'แจ้งผลการพิจารณา อบรม / เดินทางไปปฏิบัติงาน',
                                            header: this.TypeProject == '1' ? 'โครงการ ' + this.Project.Project_name : this.Project.Project_name,
                                            peridToSend: this.Project.Create_By,
                                            peridToReceive: this.MeData[0].perid,
                                            body: this.TypeProject == '1' ? '<p style="font-size: 25px;color: #364eff;font-weight: bold">โครงการ ' + this.Project.Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                                '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                                '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ManageProject/Project">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                                '<hr style="margin-top: 50px;">' +
                                                '<p style="font-size: 16px;color: #ff6d81">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                                '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                                                '<p style="font-size: 25px;color: #364eff;font-weight: bold">' + this.Project.Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                                '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                                '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ManageProject/Project">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                                '<hr style="margin-top: 50px;">' +
                                                '<p style="font-size: 16px;color: #ff6d81">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                                '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                                          })
                                          /* axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.Project_code, {
                                             active: '1'
                                           }, headerAxiosUpdate)*/
                                          this.$swal.fire({
                                            icon: 'success',
                                            title: 'บันทึกข้อมูลสำเร็จ'
                                          })
                                          this.typeStatus = 'A'
                                          this.init()
                                          this.Details_Cordi = false
                                        } else {
                                          this.$swal.fire({
                                            icon: 'error',
                                            title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง !!'
                                          })
                                        }
                                      })
                                    }
                                  }
                                })
                              })
                            } else {
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง !!'
                              })
                            }
                          })
                        } else {
                          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                            queryName: 'updateStatusProject',
                            param: btoa(JSON.stringify({
                              IsPlanStatus: this.Approve_m,
                              Project_code: this.Project_code,
                              perid: this.MeData[0].perid,
                            }))
                          }).then(async res => {
                            if (res.data.status) {
                              await this.AddCompetency()
                              this.SendMail({
                                headerName: this.TypeProject == '1' ? 'แจ้งผลการพิจารณาโครงการ' : 'แจ้งผลการพิจารณา อบรม / เดินทางไปปฏิบัติงาน',
                                header: 'โครงการ ' + this.Project.Project_name,
                                peridToSend: this.Project.Create_By,
                                peridToReceive: this.MeData[0].perid,
                                body: this.TypeProject == '1' ? '<p style="font-size: 25px;color: #364eff;font-weight: bold">โครงการ ' + this.Project.Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                    '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                    '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ManageProject/Project">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                    '<hr style="margin-top: 50px;">' +
                                    '<p style="font-size: 16px;color: #ff6d81">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                                    '<p style="font-size: 25px;color: #364eff;font-weight: bold">' + this.Project.Project_name + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                    '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                    '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ManageProject/Project">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                    '<hr style="margin-top: 50px;">' +
                                    '<p style="font-size: 16px;color: #ff6d81">โครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                              })

                              /*axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.Project_code, {
                                active: '1'
                              }, headerAxiosUpdate)*/
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                              this.typeStatus = 'A'
                              this.init()
                              this.Details_Cordi = false
                              this.dialogFormConside = false
                            }
                          })
                        }
                      }
                    })
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
                    })
                  }
                })
              }
            })
          }
        }
      }).catch(reason => {
        console.log('Reject = ' + reason)
      })
    }
  },
  mounted() {
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.dialogLoading = true
    if (this.TypeProject == null) {
      this.changeTypeProject({
        type: '1'
      })
    }
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '9'
        })

        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            this.PermissionAdmin.map(Per_i => {
              if (Per_i.permission_id == '1000') {
                this.getMenuPermissData().then(res => {
                  if (res) {
                    if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '9' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '9' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '9' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
              }
            })
            this.CheckAdmin = true
            this.dialogLoading = false
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(res => {
              if (res) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '1000') {
                    this.getMenuPermissData().then(res => {
                      if (res) {
                        if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '9' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '9' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '9' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '9')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                      }
                    })
                    this.CheckSubAdmin = true
                    this.dialogLoading = false
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-autocomplete >>> disabled {
  color: black;
}

.v-autocomplete >>> label {
  color: black;
}

.v-list .v-list-item--active {
  background-color: green !important;
}

.v-list .v-list-item--active .v-list-item__title {
  color: #ffd54f !important;
}

.input-group--disabled.input-group--select label {
  color: #000 !important;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}

/*.style-chooser vs__disabled{*/
/*    color: #ff6d81;*/
/*}*/
/*.style-chooser .vs__search::placeholder,*/
/*.style-chooser .vs__dropdown-toggle,*/
/*.style-chooser .vs__dropdown-menu {*/
/*    background: #dfe5fb;*/
/*    border: none;*/
/*    color: #ff6d81;*/
/*    text-transform: lowercase;*/
/*    font-variant: small-caps;*/
/*}*/

/*.style-chooser .vs__clear,*/
/*.style-chooser .vs__open-indicator {*/
/*    fill: #394066;*/
/*}*/
</style>
